// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/SFPro/SFProText-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/SFPro/SFProText-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/SFPro/SFProText-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/SFPro/SFProText-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Roboto/Roboto-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/icon/icone-x-bleue3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/icon/refresh2.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'SF Pro';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'SF Pro Light';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
}

body {
  /* font-family: 'Open Sans', cursive; */
  /* font-family: 'Roboto', cursive; */
  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif;
  background-color:#e8e8e8;

  /* background-color:red; */
  /* position: fixed; */
}

.row {
  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif;
}

.mob {
  margin-left: 0px;
}

.row {
  margin-left: 0px;
  margin-right: 0px;
}

.mobdata {
  position: relative;
  align-items: left;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 15px;
  vertical-align: top;
}

.hex {
  width: 318px;
  height: 318px;
  margin: 50px auto;
  position: relative;
}

.hex:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 80px solid transparent;
  border-top: 0px solid #F3F5F6;
  border-left: 145px solid #F3F5F6;
  top: 0;
  left: 0;
  z-index: 9999;
}

.hex:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 80px solid transparent;
  border-top: 0px solid #F3F5F6;
  border-right: 145px solid #F3F5F6;
  top: 0;
  right: 0;
  z-index: 9999;
}

.hex-title {
  width: 105%;
  height: 40px;
  background: #005A87;
  position: absolute;
  margin: auto;
  left: -2.5%;
  top: 0;
  bottom: 0;
  z-index: 99999999999;
  font-family: Arial;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.hex-img {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.hex-img img {
  max-height: 100%;
}

.hex-hide {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.hex-hide:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 80px solid transparent;
  border-bottom: 0px solid #F3F5F6;
  border-left: 145px solid #F3F5F6;
  bottom: 0;
  left: 0;
  z-index: 9999;
}

.hex-hide:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 80px solid transparent;
  border-bottom: 0px solid #F3F5F6;
  border-right: 145px solid #F3F5F6;
  bottom: 0;
  right: 0;
  z-index: 9999;
}

@viewport {
  width: device-width;
  /* width: min-content; */

}

.logo {
  align-self: left;
  margin-top: -10px;
  z-index: 3;
  margin-left: 86%;
  opacity: 85%;
  position: absolute;
  filter: invert;
  background-color: transparent;
}

.logo-spread {
  align-self: left;
  margin-top: 0px;
  z-index: 3;
  position: absolute;
  margin-left: 145px;
}

.logo-will {
  align-self: left;
  margin-top: 15px;
  z-index: 3;
  position: absolute;
  margin-left: 453px;
}

.hexdata {
  position: relative;
  vertical-align: top;
  opacity: 0.5;
  z-index: 2;
}

.hexdata1 {
  text-align: right;
  vertical-align: top;
  margin-top: -25px
}



.smartphone_new {
  background: white;
  position: absolute;
  min-height: 100%;
  margin: auto;

  margin-top: 10px;
  margin-left: 80px;
  border: 0px #cccccc solid;
  align-items: center;
  /* border-top-width: 60px;
      border-bottom-width: 60px;
      border-radius: 36px   */
}

.media {
  width: auto;
  height: 50rem;
  object-fit: contain;
}

.slide_data {
  vertical-align: top;
}

.react-player {
  position: absolute;
  top: 0;
  left: 0;
}

/******************************/
.content {
  text-align: left;
}

.content h1 {
  font-family: 'Sansita', sans-serif;
  letter-spacing: 1px;
  font-size: 50px;
  color: #282828;
  margin-bottom: 10px;
}

.content i {
  color: #FFC107;
}

.content span {
  position: relative;
  display: inline-block;
}

.content span:before,
.content span:after {
  position: absolute;
  content: "";
  background-color: #282828;
  width: 20px;
  height: 2px;
  top: 40%;
}

.content span:before {
  left: -5px;
}

.content span:after {
  right: -45px;
}

.content p {
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  letter-spacing: 1px;
}

.wrapper {
  position: relative;
  display: inline-block;
  border: none;
  font-size: 14px;
  margin: 10px auto;
  left: 10px;
  transform: translateX(-50%);
  width: auto;
  height: auto;

}

.wrapper input {
  border: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
  position: absolute !important;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  opacity: 0;
}


.wrapper label {
  position: relative;
  float: right;
  color: #C8C8C8;
}

.wrapper label:before {
  margin: 5px;
  content: "\\f005";
  font-family: FontAwesome;
  display: inline-block;
  font-size: 1.5em;
  color: #ccc;
  -webkit-user-select: none;
  user-select: none;
}

.wrapper input:checked~label:before {
  color: #FFC107;
}

.wrapper label:hover~label:before {
  color: #ffdb70;
}

.wrapper label:hover:before {
  color: #FFC107;
}

.kudimage {
  /* margin-top: 3px; */
  /* height: 25px; */
  /* margin-left: -7px; */
  padding: 2px;
}

.saysimage {
  /* margin-top: 3px; */
  /* height: 25px; */
  /* margin-left: 5px; */
  padding: 2px;
}

.spreadimage {
  /* margin-top: 3px; */
  /* height: 25px; */
  /* margin-right: 10px; */
  padding: 2px;
}

.say_image {
  margin-top: 3px;
  height: 20px;
}

.grayscale {
  filter: grayscale(100%);
  text-align: right;
  flex: 2 1;
  height: 20px;
}

.textdata {
  margin-top: 15px;
  position: relative;
  float: left;
  text-align: left;
  word-wrap: break-word;
}

.caption_data {
  line-height: 1em;
  height: 2em;
  overflow: hidden;
  text-align: justify;
  position: relative;
  align-items: left;
  margin-left: 0px;
  margin-top: 10px;
  padding-top: 0px;
  padding-left: 0px;
  word-wrap: break-word;
  word-break: break-word;
  height: auto;
}

.image_profile {
  /* width: 45px;
  height: 45px; */
  padding-top: 0px;
  margin-left: 0px;
  align-self: left;
  align-content: left;
}

.image_profile_spread {
  width: 50px;
  height: 60px;
  padding-top: 5px;
  padding-left: 0px;
  margin-left: 23px;
}

.imagedata {
  align-items: left;
  max-width: 45px;
  height: auto;
}

.mobdata1 {
  text-align: right;
  position: relative;
  float: left;
  vertical-align: text-top;
  max-width: 453px;
  height: auto;
}

.miledata {
  font-size: 11px;
  position: relative;
  padding-left: 2px;
  width: 50%;
}

.app-image-gallery {
  width: 500px;
  height: 500px;
}

.app-image-gallery-travel {
  width: 453px;
  height: 453px;
  margin-left: 0px;
  object-fit: fill;
}

.app-image-gallery-place {
  width: 453x;
  height: 453px;
}

.app-image-gallery-media {
  width: 453px;
  height: 453px;
}

.app-image-gallery_horz {
  width: 453px;
  height: 453px;
}

.app-image-gallery-map {
  width: auto;
  height: 453px;
  margin-left: 10px;
  max-width: 900px;
}

.app-image-gallery-explurge {
  width: auto;
  height: 453px;
}

.image_total_horz {
  width: auto;
  height: 318px;
  margin-left: 10px;
  max-width: 900px;
}

.image_total {
  min-width: 453px;
  max-height: 800px !;
  object-fit: fill;
}

.image_slide {
  width: 453px;
  height: 453px;
  object-fit: fill;
}

.image_slide_map1 {
  min-width: auto;
  max-height: 318px;
  float: left;
}

.image_slide_map_will_travel {
  width: 350px;
  height: 350px;
  margin-left: 20px;
  object-fit: fill;
}

.image_slide_map_will_travel1 {
  width: 350px;
  height: 350px;
  margin-left: 20px;
  margin-top: 110px;
}

.image_slide_map2 {
  min-width: 318px;
  max-height: 318px;
  object-fit: fill;
}

.image_slide_map_explurge1 {
  width: 453px;
  height: 453px;
  align-items: left;
  cursor: none;
}

.image_slide_map_explurge2 {
  width: 100%;
  height: auto;
  max-width: 600px;
  max-height: 318px;
  object-fit: fill;
}

.image-gallery-slide .image-gallery-image-new {
  width: 453px !important;
  height: 453px !important;
  margin-left: 40px;
}

.image-gallery-image-travel {
  width: 453px;
  height: 453px;
  object-fit: fill;
  margin-left: 0px;
}

.image-gallery-slides.image-gallery-image-travel_1 {
  width: 550px ! important;
  height: 550px ! important;
  display: inline-block;
}

.image-gallery-image-media {
  width: 100%;
  height: 453px;
  min-width: 453px;
  max-height: 453px;
  object-fit: fill;
}

.image-gallery-image-horz {
  width: 100%;
  height: 318px;
  min-width: 318px;
  max-height: 453px;
  object-fit: fill;
}

.video-wrapper {
  width: 100%;
  height: auto;
}

.video-wrapper-travel {
  width: 100%;
  height: auto;
  margin-top: 0px;
  padding-top: 0px;
}

.image-gallery-slides {
  align-items: left !;
  text-align: left;
}

.image-gallery-bullets .image-gallery-bullets-container {
  padding: 0;
  text-align: left !;
}

.slide-image-data {
  padding: 0;
  vertical-align: top;
  margin-left: 0px;
  max-width: 100%;
  height: auto;
}

.image-gallery-content {
  margin-left: 0px;
}

.image-image-travel {
  width: 350px;
  height: 175px;

}

.image-image-media {
  width: 350px;
  height: 350px;
  max-width: 100%;
  max-height: 453px;
  min-width: 350px;
  object-fit: cover;
  object-position: bottom;
}

.image-image-media-place {
  width: 200px;
  height: 200px;
  float: left;
  position: relative;
}

.image-place-thumb {
  position: relative;
  float: left;
}

.image-image-travel-place {
  width: 350px;
  height: 175px;
  vertical-align: top;
}

.will-travel-place {
  position: relative;
  float: left;

}

.will-travel-map {
  margin-top: 0;
  vertical-align: top;
  position: relative;
  float: left;
  width: 318px;
  height: 100px;
  margin-left: 20px;

}

.will-travel-map2 {
  margin-top: 0;
  margin-left: 20px;
  width: 100px;
  height: 100px;
}

.explurge-travel-map {
  margin-top: 0;
  width: 200px;
  height: 200px;
  position: relative;
  float: left;
}

.explurge-travel-map2 {
  margin-top: 0;
  margin-left: -30px;
  vertical-align: top;
  width: 453px;
  height: 200px;
}

.explurge-travel-map-map {
  margin-top: 0;
  margin-left: 0px;
  max-width: 100%;
  max-height: 100px;
  width: 453px;
  object-fit: cover;
  height: auto;
}

.mob_line_bottom {
  border: 1.1px solid #E6E6E6;
  padding-top: 0px;
  padding-left: 0px;
  margin-left: 0px;
  margin: 5px 0;
  width: 100%;
  max-width: 100%;
}

.mob_line_top {
  margin-top: 10px;
  margin-right: 0px;
}

.videodata {
  width: 500px;
  height: 500px;
}

.cardbody {
  width: auto;
}

.customedata {
  height: auto;
  width: 40%;
  position: relative;
  float: left;
  background-color: #F2F3F4;
}

.image-map {
  margin-left: -100px;
}

.map-image {
  margin-left: 0px;
  object-fit: cover;
}

.travel-data {
  margin-left: 10px;
  margin-right: 0px;
  width: 500px;
  align-items: center;
  background-color: dodgerblue;
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 0px;
}

.profile-post-line {
  margin-left: 0px;
  position: relative;
  float: left;
  margin-top: 10px;
  justify-content: center;
}

.profile-post-line-right {
  margin-left: 0px;
  margin-top: 10px;
  width: 70%;

}

.profile-image-post-line {
  margin-left: 0px;
}

.play_but_img {
  z-index: -1;
  position: absolute;
  top: 130px;
  left: 160px;
  align-items: center;
  opacity: 0.6;
}

.video {
  border: 5px solid red;
  /*Your CSS here for styling*/
}

.app-text {
  margin-left: 10px;
}
/*
.image_profile_post {
  width: 385px;
  height: 385px;
}
*/

.textcolor {
  height: 100px;
  width: 60%;
  position: relative;
  float: left;
  background-color: #646464;
  word-wrap: break-word;
  word-break: break-word;
  text-align: left;
}

.textcolor-noimage {
  position: relative;
  background-color: #F2F3F4;
  width: 100%;
  height: auto;
  margin-left: 0px;
  padding-left: 0px;
  word-wrap: break-word;
  text-align: left;
  font-size: 12px;
}

/*********************************/
.slider-with-video img,
.slider-img img {
  max-width: 100%;
}

.post-details {
  margin-top: 15px;
  margin-left: 0px;
}

.post-details-inner {
  position: relative;
  float: left;
  width: 85%;
  padding-top: 14px;
  padding-left: 15px;
  left: 5%;
  height: auto;
  word-wrap: break-word;
}

.whitescale {
  filter: invert(1);
}

.date-color {
  font-family: 'Open Sans', sans-serif;
  color: #646464;
  font-size: 0.875em;
}

#more {
  display: none;
}

.traveltext {
  margin-top: 10px;
}

.creater_thumbpic {
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  position: relative;

}

.frame-fix {
  max-width: 500px;
  max-height: 500px;
  position: relative;
  margin: auto;
}

.image-kudo {
  position: relative;
  float: left;
  margin-top: 0px;
}

/*************************************/

.card_main {
  position: relative;
  padding-top: 0px;
  margin-top: 0px;
  ;
  /**************/
  border-radius: 25px;
  border: 2px solid #cccccc;
  padding: 20px;
  width: 500px;
  max-width: 500px;
  height: 900px;
  max-height: 100%;

  align-content: center;
  padding-left: 0px;
  margin-left: 10px;
  font-size: 12px;
  /*****************/

}

/*.card {  
    position:relative;
    padding-top: 0px;
    margin-top:0px;;
    border: 1px solid #cccccc;
    padding: 20px; 
    max-width:600px;
    height: 900px;
    max-height:900px;
    align-content: center;
    padding-left:0px;
    margin-left:10px;
    font-size:10px;       
    }*/

/*
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

body {
  background-color: #003066;
} */
.container-frame {
  padding-top: 0px;
  margin-top: 5px;
}

.card-inner {
  max-width: 50rem;
}

/***********************************/
.footer-left {
  position: fixed;
  float: left;
  width: 100%;
}

.footer-left-inner1 {
  width: 40%;
  margin-top: 0px;
  text-align: center;
  position: relative;
  float: left;
}

.footer-left-inner2 {
  width: 30%;
  margin-top: 0px;
  text-align: center;
  position: relative;
  float: left;

}

.footer-left-inner3 {
  width: 30%;
  margin-top: 0px;
  text-align: center;
  position: relative;
  float: left;
}

.footer-left-inner4 {
  width: 40%;
  margin-top: 0px;
  text-align: left;
  position: relative;
  float: left;
}
.footer-left-inner5 {
  width: 60%;
  margin-top: 0px;
  text-align: right;
  position: relative;
  float: right;
}

@media screen and (min-width: 768px) {
  .footer-left-inner4 {
    width: 45%;
    margin-top: 0px;
    text-align: left;
    position: relative;
    float: left;
    padding: 0 5px;
  }
  .footer-left-inner5 {
    width: 55%;
    margin-top: 0px;
    text-align: right;
    position: relative;
    float: right;
    padding: 0 5px;
  }

  .kudo-count-container {
    margin-left: 5px;
  }
}

.bucket-area {
  background-color: #0195F7;
  display: inline-block;
}

.bucket-inner {

  float: left;
  color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-weight: bold;
  align-items: right;
}

.bucket-inner1 {
  color: #ffffff;
  font-size: 12px;
  width: 20%;
  font-weight: normal;
  font-weight: bold;

}

.bucket-inner2 {
  color: #ffffff;
  font-size: 12px;
  width: 20%;
  font-weight: normal;
  font-weight: bold;

}

.bucket-inner3 {
  color: #ffffff;
  font-size: 12px;
  width: 20%;
  font-weight: normal;
  font-weight: bold;

}

.bucket-inner4 {
  width: 20%;
}

.bucket-inner5 {
  color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-weight: bold;
  align-items: right;
  margin-top: 0px;
  padding-top: 5px;
  z-index: 2;
}

.btn-text {
  border-radius: 15px;
  background-color: white;
  color: blue;
  align-items: right;
  border-color: #ffffff;
  padding-left: 5px;
  margin-left: 40px;
  margin-top: 7px;
  height: 30px;
}

.btn-text-down {
  background-color: #0195F7;
  height: 35px;
  margin-left: 0px;
  margin-top: 0px;
  padding-top: 0px;
  width: 100%;
}

.btn-text-travel {
  position: absolute;
  background-color: #0195F7;
  height: 40px;
  margin-top: 0px;
  position: relative;
  width: 100%;
}

.btn-text-travel_no {
  background-color: #0195F7 ! important;
  height: 40px;
  margin-top: 0px;
  position: relative;
  width: 100%;
}

.btn-text-spread {
  font-size: 10px;
  ;
  background-color: #0195F7;
  height: 35px;
  margin-left: 0px;
  margin-top: 0px;
  padding-top: 0px;
  width: 90%
}

.btntxt {
  width: 30%;
  border-radius: 15px;
  background-color: white;
  color: #2196F3;
  align-items: right;
  border-color: #ffffff;
  padding-left: 5px;
  margin-left: 15px;
  margin-top: 8px;
  height: 20px;
  margin-right: 5px;
  font-size: 10px !important;
}

.btn-left {
  width: 10%;
  margin-top: 3px;
  margin: left 0px;
  float: left;
  color: #ffffff;
}

.travel-place-map {
  width: 318px;
  height: 100px;

}

.travel-place-image {
  width: 135px;
  height: 100px;
}

.expl-place-image {
  max-height: 200px;
  align-items: stretch;
  object-fit: cover;
  padding: 0px;
}

.expl-place-map {
  margin-left: 0px;
  margin-top: 0px;
  padding: 0px;
  padding-left: 0px;
  width: 60%;
  height: 100%;
  object-fit: cover;
  padding: 0px;

}

.footer-images {
  width: 100%;
  max-width: 100%;
  max-height: 200px;
  padding-top: 0px;
  margin-top: 0px;
}

.image-2 {
  position: fixed;
  max-height: 200px;
  max-width: 453px;

}

.img-fluid {
  height: 200px !important;
  object-fit: cover;
  padding: 0px;
}

.card_add {
  width: 100%;
  background-color: #FDFFFD;
}

.phone {
  padding-top: 0px;
  display: flex;
  align-items: center;
  width: 478px;
  max-height: 100%;
  height: 900px;
  background: #cccccc;
  border-radius: 30px;
  border-color: red;
  padding: 10px;
  border: 2px;
}

* .container img {
  display: inline-block;
  height: 100px;
  z-index: 0;

}

img.right_image {
  width: 70%;
  height: 100px;
  max-width: 318px;
  object-fit: cover;
  z-index: -1;
}

img.left_image {
  float: left;
  width: 30%;
  max-width: 318px;
  height: 100px;
}

img.leftimage {
  float: left;
  width: 30%;
}

img.leftimage_2 {
  float: left;
  width: 70%;
  margin-top: 0px;

}

img.rightimage_2 {
  float: left;
  width: 30%;
  margin-top: 0px;
}

img.rightimage {
  float: left;
  width: 70%;
  padding-right: 0px;
}

.left_image_spread {
  float: left;
  width: 70%;
}

.right_image_spread {
  float: left;
  width: 30%;
}

.col-md-6 {
  float: left;
  object-fit: contain;
  ;
}

.container-single {
  width: 100%;
}

.side-pro-kudo {
  position: relative;
  float: left;
}

.upper-image-map {
  position: relative;
  float: left;
}

.container {
  margin-top: 0px;
  padding-left: 0px;
  margin-left: 0px;
  width: 100%;
  height: auto;
  z-index: 1;
  padding-right: 0px;
}

.img-left {
  position: relative;
  float: left;

}

.img-circle {
  border-radius: 50%;
  width: 20px;
  margin-top: 0px;
}

.data-resp {
  position: absolute;
  display: inline-block;
  width: 318px;
  max-width: 100%;
  padding-top: 0px;
  padding-left: 0px;
  word-break: break-all;
  /* optional */
}

.square {

  border-color: #cccccc;
  border-width: 4px;
  width: 480px;
  height: 900px;
  padding: 5px;

}

.square h1 {
  color: #fff;
}

.image-gallery-center {
  z-index: 2;
}

.min_profile {
  width: 80%;
}

.img_data {
  width: 15%;
  position: relative;
  float: left;
  padding: 10px 0; 
}

.block-box {
  background-color: #FDFFFD;
  font-family: 'Open Sans';
  font-size: 10px;
  position: relative;
  /*border: 2px solid #cccccc;*/
  margin: 0px;
  padding-top: 0px;
  margin-top: 0px;
  height: auto;
  max-height: 900px;
  display: flex;
  align-content: center;
  border-radius: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 4px;
  justify-content: center;
}

.block-pro {
  width: 100%;
  padding: 0px;
  margin: 0px;

}

.box-5 {
  width: 100%;
  height: auto;
  padding: 0px;
  margin: 0px;
  margin-top: 0px;
  font-size: 12px;
}

.box-1 {
  display: block;
  position: relative;
  /* border:.4px solid #cccccc; */
  width: 100%;
  height: auto;
  padding: 0px;
  padding-left: 0px;
  margin: 0px;
  z-index: 0px;
  /* margin-top: -5px; */
  margin-left: 0px;
}

.box-spraed-1 {
  display: block;
  position: relative;
  border: .4px solid #cccccc;
  width: 96%;
  height: auto;
  margin: 6px;
  z-index: 0px;
  margin-top: 5px;
  margin-left: 5px;
}

.box-2 {
  width: 100%;
  height: 100px;
  padding: 0px;
  margin: 0px;
  margin-top: 0px;
}

.box-4 {
  width: 350px;
  height: 350px;
  padding: 0px;
  margin: 0px;
  border: 1px solid #cccc;

}

.box-3 {
  border-color: #FDFFFD;
  width: 100%;
  height: auto;
  padding: 0px;
  margin: 0px;
  margin-top: 0px;
}

.limage {
  float: left;
  width: 70%;
  max-width: 318px;
}

.rimage {
  width: 30%;
  max-width: 115px;
}

.card-body {
  padding: 0px;
}

.data-match {
  width: 78%;
  padding-top: 20px;
  /* padding-left: 1em; */
  font-size: 13px;
  /* text-align: justify; */
  overflow: hidden;
  display: inline-block;
  /* margin-left: -15px; */
}

.imgclass {
  position: relative;
  float: left;
  padding-top: 0px;
  margin-top: 3px;
  margin-left: 1px;
}

.linkclass {
  object-fit: cover;
}

.imgclassrun {
  margin-top: -5px;
  padding-top: -5px;
  padding-left: 4px;
}

.kudotext {
  position: relative;
  float: left;
  /* padding-left:4px;
  padding-top:0px;
  margin-top:-2px; */
  color: #646464;

}

.say_spread_text {
  text-align: right;
  margin-top: 0px;
  padding-top: 0px;
}

.dot {
  height: 4px;
  width: 4px;
  padding-top: 0px;
  margin-top: 11px;
  margin-left: 7px;
  background-color: #646464;
  border-radius: 50%;
  float: left;
}

.dot-say {
  position: relative;
  float: left;
  margin-left: 10px;
  text-align: right;
  color: #646464;
}

.dot-spread {
  position: relative;
  float: left;
  margin-right: 0px;
  text-align: left;
  color: #646464;
}

.kudo-alldata {
  float: left;
  width: 55%;
  padding-left: 0px;
  padding-top: 0px;
}

.data_left {
  position: relative;
  float: left;
  /* padding-left: 2px; */
}

.play_icon {
  background: none;
  width: 100px;
  height: 50px;
  border: solid 5px #fff;
  border-radius: 100%;
  position: absolute;
  text-indent: -9999px;
  box-shadow: 1px 1px 3px #999999;
  z-index: 1;
  padding-left: 0px;
  padding-top: 0px;
  margin-left: 10em;
  margin-top: 10em;
}

.justify-content-center {
  z-index: 0 ! important;
  left: 0px;
  margin-left: 0px;
}

.image-gallery-bullets {
  background-color: transparent;
  /* outline: 2px dashed; */
  /* transform: rotate(180deg); */


}

.travel_data {
  padding-top: 20px;
  padding-left: 10px;
  font-size: 14px;
  color: #ffffff;
  float: left;
  font-weight: bold;

}

.traveltxt {
  font-size: 12px;
  color: #ffffff;
  float: left;
  text-align: center;
  padding-top: 0px;
  margin-top: -2px;
  float: left;
  padding-left: 20px;

}

.traveltxt_days {
  font-size: 12px;
  color: #ffffff;
  float: left;
  text-align: center;
  padding-top: 0px;
  margin-top: -36px;
  padding-left: 20px;
  margin-left: 0px;

}

.traveltxt_days-only-u {
  font-size: 12px;
  color: #ffffff;
  float: left;
  text-align: center;
  padding-top: 0px;
  margin-top: -36px;
  padding-left: 20px;
  margin-left: 0px;
}

.traveltxt_days-only-d {
  font-size: 12px;
  color: #ffffff;
  float: left;
  text-align: center;
  padding-top: 0px;
  margin-top: -2px;
  padding-left: 20px;
  margin-left: 0px;
}

.traveltxt_days_up {
  font-size: 12px;
  color: #ffffff;
  float: left;
  text-align: center;
  padding-top: 0px;
  margin-top: -35px;
  padding-left: 20px;
  margin-left: 0px;
}

.traveltxt_days_down {
  font-size: 12px;
  color: #ffffff;
  float: left;
  text-align: center;
  padding-top: 0px;
  margin-top: -2px;
  padding-left: 20px;
  margin-left: 0px;
}

.traveltxt_days_down {
  font-size: 12px;
  color: #ffffff;
  float: left;
  text-align: center;
  padding-top: 0px;
  padding-left: 20px;
  margin-left: 0px;
}

.pic-travel {
  font-size: 8px;
  color: #ffffff;
  padding-top: 1px;
  padding-left: 0px;
  margin-top: 1px;
  margin-left: 3px;
  float: left;
}

.pic-travel_upper {
  font-size: 8px;
  color: #ffffff;
  padding-top: 6px;
  padding-left: 0px;
  margin-top: 0px;
  margin-left: 0px;
  float: left;
}



.travel_time {
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;

}

.notouch {
  cursor: pointer;
  pointer-events: auto;
  margin-right: 0px;
  margin-left: 0px;
  align-items: center;

}

.cover_image_profile {
  padding-top: 0px;
  margin-left: 0px;
  align-self: left;
  align-content: left;
  background-color: #cccccc;
  height: auto;
  max-width: 100%;
}

.text-text {
  text-align: justify;
  text-justify: inter-word;
}

.btnmark {
  background-color: white;
  padding-top: 0px;
  margin-top: -10px;
}

.blanktab {
  width: 10%;
}

.sayonly {
  width: 45%;
  padding-left: 0px;

}

.sayonly1 {
  width: 50%;
  text-align: right;
  margin-left: 40px;
}

.sayonly2 {
  width: 50%;
  text-align: right;
  margin-left: 40px;


}

.btn-bucket-center {
  font-size: 11px;
  color: #ffffff;
  float: left;
  margin-top: 9px;
  padding-left: 5px;

}

.strokclass {
  stroke: #f0ebeb;
  stroke-width: 2;
}

.side-upper {
  margin-top: -10px;
  /*padding-bottom: 3px; */
}

.kudo-mark {
  margin-top: 5px;
  margin-right: 5px;
}

.test_data {
  margin-top: 0px;
  margin-right: 0px;
}

.truncate {
  position: relative;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  /* number of lines to show */
  line-clamp: 5;
  -webkit-box-orient: vertical;
}

.subtruncate {
  position: relative;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.button {
  font-family: 'open-sens';
  font-size: .875em;
}

.textcolor_noimage {
  height: auto;
  background-color: #F2F3F4;
}

.capstext {
  position: relative;
  float: left;
}

.ml {
  margin-left: 2px;
}

.domaindata {
  padding-left: 2px;
  color: #646464;
  text-decoration: none;
}

.textml {
  position: relative;
  float: left;
}

.image_profile_post1 {
  margin-top: 4px;
  height: 45px;
  margin-left: 10px;
  margin-bottom: -5px;
  stroke-width: 1.5px;
  stroke: #726d6d;
}

.kudoImg {
  height: 25px;
}

.kudo {
  margin-left: 350px;
}

.says {
  margin-left: 350px;
}

.spread {
  margin-left: 350px;
}

.kudosView {
  /* margin-top: -18px; */
}

.milesImg {
  height: 17px;
  /* filter: saturate(0.5); */
  margin-bottom: 6px;
}

.milesText {
  color: #2d58a8;
}

.postString {
  margin-left: 3px;
}

.nameMiles {
  -webkit-text-decoration: dashed;
          text-decoration: dashed;
}

.mediaImg {
  width: 398px;
  height: 238.8px;
}

.postCard {
  width: 425px;
  max-height: 750px;
  
}

.postCard2 {
  width: 425px;
  max-height: inherit;
}

.postCard3 {
  width: 425px;
  max-height: inherit;
}

.postCard3 .box-1 .BoxPostWoner {
  /* border: .4px solid #cccccc; */
}

.p101010{
  padding: 0 10px 10px 10px;
}

.Map_Place_Thumb_Photo {
  object-fit: cover;
  width: 136px;
  height: 148px;
}

.Map_Place_Photo_Url {
  object-fit: cover;
  width: 290px;
  height: 148px;
  margin-left: -1px;
}


.postText {
  font-size: small;
  word-wrap: break-word;
}

.previewTitle,
.previewDesc,
.previewLink {
  font-size: small;
  word-wrap: break-word;
}

.previewImg {
  object-fit: cover;
  /* height: 425px;
  width: 360px; */
  width: 100%;
  height: auto;
}

.badg-verified {
  height: 18px;
  margin-right: 2px;
}

.loader {
  /* margin-left: 200px; */
}

.mainLoader {
  border-color: rgb(37 89 177) rgb(37 89 177) transparent !important;
}

.kudosView {
  font-size: small;
  padding: 10px 0px;
}

.videoView {
  object-fit: cover;
  /* height: 425px;
  width: 425px; */
  cursor: pointer;
}

.videoExplrView {
  object-fit: cover;
  /* height: 425px;
  width: 100%; */
  cursor: pointer;
  /* padding-bottom: 15px; */
}
.videoExplrView225 {
  object-fit: cover;
  /* height: 225px;
  width: 100%; */
  cursor: pointer;
  /* padding-bottom: 15px; */
}

.imageView {

  height: inherit;
  width: inherit;

}

.imageViewBox {
  object-fit: cover;
  /* height: 425px;
  width: 100%; */
}
.imageViewBox2 {
  object-fit: cover;
  /* height: 425px;
  width: 100%; */
}
.imageViewBox3Single {
  object-fit: cover;
  /* max-height: fit-content; */
  /* width: 100%;
  height: 425px; */
}

.imageViewBox225 {
  object-fit: cover;
  /* height: 225px;
  width: 100%; */
}

.profilePic {
  object-fit: cover;
  /* height: 425px;
  width: 100%; */
}

.coverPic {
  object-fit: cover;
  /* height: 250px;
  width: 425px; */
  /* width: 100%; */
  /* height: auto; */
  /* height: 425px; */ 
}

.imageViewBoxFullScreen{
  object-fit: cover;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;  
}

.imageViewBoxFullScreen .imageViewBox {
  object-fit: cover;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;  
}

.imageViewBoxFullScreen .imageViewBox .imageView {
  object-fit: cover;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;    
}




.kudoVal {
  /* margin-left: -25px; */
}

.saysVal1 {
  margin-left: 15px;
}

.preadVal1 {
  margin-right: -38px;
}

.kudosProfile3,
.kudosProfile2,
.kudosProfile {
  width: 20px;
  border-radius: 50%;
}
@media screen and (max-width: 425px) {
  .kudosProfile2 {
    width: 18px;
  }  
  .kudosProfile3 {
    width: 13px;
  }
}


.kudosProfile:hover {
  cursor: pointer;
}

/* .cover {
  object-fit: cover;
  width: 50px;
  height: 100px;
} */

.paging-item {
  opacity: 1.5 !important;
  fill: #ffffff !important;
  width: 12px;
}

.active {
  fill: #32a8e4 !important;
}

.slider-control-centerright,
.slider-control-centerleft {
  display: none !important;
}

.slider-control-bottomcenter {
  margin: 0px !important;
}

.paging-dot {
  height: 7px;
  width: 7px;
  border: 1px solid lightslategray;
  border-radius: 100%;
}

.slider-container .slider-control-bottomcenter {
  margin-bottom: 50px !important;
}

.explurgen-with-media .imageView {
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.playIcon {
  height: 50px;
  position: absolute;
  margin-left: 12rem;
  margin-top: 12rem;
  cursor: pointer !important;
  opacity: 80%;
  background: #B73A3A3A;
  border-radius: 50px;
}

.fade:not(.show) {
  opacity: 1;
}

.video-react {
  padding-top: 0px !important;
}

/* .playIcon {
  display: none;
}
    
.videoView:hover + .playIcon {
  display: block;
} */


.scroll-div {
  height: auto;
  /* margin-top: 81px; */
  position: sticky;
}

.sticky-div {
  /* background-color: green; */
  /* position: fixed;
  top: 0px; */
  /* padding: 10px 0px; */

  top: 0px;
  display: block;
  /* left: 0px; */
  position: fixed;
  overflow: hidden;
  z-index: 1;
  width: 100%;
  max-width: 428px;
}

.top-div {
  padding: 20px 0px;
  background-color: white;
}

.top-section {
  background: #FDFFFD;
  position: fixed;
  position: fixed;
  z-index: 999;
  padding-bottom: -28px;
  height: 60px;
}

.header-data {
  display: flex;
  margin-top: 8px;
}

.logoImg {
  height: 40.83px;
  width: 78.38px;
}

.openAppBtn {
  border-radius: 25px;
  background-color: #D9D9D9;
}
.openAppBtn:hover{
  background-color: #D9D9D9;
}

.fade {
  background-color: #05040482;
}

.btn-primary {
  background-color: #0195F7;
}

.notNow {
  height: 14px;
  width: 55px;
  text-decoration: none;
  cursor: pointer;
  color: #0195F7;
  font-family: 'Roboto';
  font-size: 14px;
}

.flex-parent {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Place_Photo_Box {
  height: 136px;
  width: 30%;
}

.Place_Photo_Box img {
  width: 100%;
  height: 100%;
}

.Map_Photo_Box {
  width: 70%;
  height: 136px;
}

.Map_Photo_Box img {
  width: 100%;
  height: 100%;
}

.main {
  width: 28vw;
  margin-left: 32%;
  background: #FDFFFD;
  position: fixed;
  position: fixed;
  z-index: 999;
  padding-bottom: -28px;
  height: 60px;
}

/* .image_profile_post {
  width: 415px;
  height: 385px;
  padding-top: 0px;
  margin-left: 0px;
} */

.strokclassPost {
  stroke: #f0ebeb;
  stroke-width: 0.5;
}

.Level_Icon {
  height: 30px;
  position: absolute;
  /* top: 60px; */
  right: 0px;
  z-index: 999;
  margin-top: -14px;
}

.read-or-hide {
  cursor: pointer;
}

.AddbucketListBtn {
  border-radius: 25px;
  --bs-btn-padding-y: -0.75rem;
  --bs-btn-padding-x: 0.5;
  --bs-btn-font-size: 0.7rem;
  margin-top: 8px;
  margin-right: 8px;
  width: 100px;
  color: #0195F7;
}

.modalUserProfile .image_profile {
  width: 70px;
  height: 69.97px;
}

.modalUserProfileCenter .image_profile {
  width: 70px;
  height: 69.97px;
}

.getTheApp {
  border-radius: 30px;
  width: 100%;
  background: #0195F7;
  color: #FFFFFF;
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 14px;
  line-height: 20px;
  height: 40px;
}

.getTheApp:hover {
  background: #0195F7;
  color: #FFFFFF;
}

.getTheAppCenetr {
  top: 783px;
  left: 20px;
  border-radius: 30px;
  width: 230px;
  height: 40px;
  background: #0195F7;
  color: #FFFFFF;
  margin-bottom: 15px;
  font-size: 14px;
  line-height: 20px;
}

.getTheAppCenetr:hover {
  background: #0195F7;
  color: #FFFFFF;
}

.profile-pic-post-row{
  background: darkgray;
}
.m10px00 {
  margin: 10px 0px 0px;
}
.m0 {
  margin: 0px;
}
.m5_0 {
  margin: 5px 0px;
}
.p0 {
  padding: 0px;
}
.p1 {
  padding: 1px;
}
.p2 {
  padding: 2px;
}
.p3 {
  padding: 3px;
}
.p4 {
  padding: 4px;
}
.p5 {
  padding: 5px;
}

.plr0 {
  padding-left: 0px;
  padding-right: 0px;
}
.w33p {
  width: 33%;
}
.w67p {
  width: 67%;
}

.img_container1 {
  width: 33%; /* adjust to container size as needed */
  /* height: 500px; adjust to container size as needed */
  /* height: 425px; */
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img_container2 {
  width: 67%; /* adjust to container size as needed */
  /* height: 500px; adjust to container size as needed */
  /* height: 425px; */
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img_container1 img, .img_container2 img, .imageViewBox img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  /* object-fit: contain; */
  /* object-fit: cover; */
  object-fit: fill;
  vertical-align: middle;
}

.vjs-poster img {
  object-fit: fill !important;
}

.imageViewBox2 img, .imageViewBox3Single img, .imageViewBox225 img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  vertical-align: middle;
  object-fit: fill;
}

.kudo-count-container {
  justify-content: center;
  display: flex;
  float: left;
  /* margin-left: 25px; */
}
.kudo-user-names {
  float: left;
}
.kudo-user-names img {
  margin-left: 1px;
}
.kudo-counts {
  margin-left: 5px;
  float: left;
}

.fll {
  float: left;
}
.flr {
  float: right;
}


.videoViewCount {
  position: absolute;
  background-color: black;
  box-sizing: border-box;
  font-size: 14px;
  color: #ffF;
  z-index: 1;
  padding: 0px 3px 0px 0px;
  border-bottom-right-radius: 20%;
}

.videoViewCount_Icon {
  height: 10px;
  margin: 0px 2px 2px;
}

.seeTheFullProfileInAppModalDialog {
  /* margin-top: 573px; */
  width: 100%;
  /* margin-left: 0px; */
  position: fixed;
  /* top: auto;
  right: auto;
  left: auto; */
  bottom: -78.5px;
  /* padding: 0px 1px; */
}

.seeTheFullProfileInAppModalDialog.midSeeMorePopup {
    max-width: 330px;
}

.dontMissModalDialog {
  /* margin-top: 372px;
  width: 335px;
  margin-left: 5px; */
  position: fixed;
  /* top: auto;
  right: auto;
  left: 5%; */
  width: 80%;
}

/* On screens that are 600px wide or less, the background color is olive */
@media screen and (max-width: 600px) and (max-width: 767px) {
  /* body {
    background-color: rgb(236, 236, 232);
  } */

  .main {
    width: 100vw;
    margin-left: -12px;
    background: #FDFFFD;
    position: fixed;
    position: fixed;
    z-index: 999;
    padding-bottom: -28px;
    height: 55px;
  }

  .flex {
    display: flex;
    gap: 16px;
  }

  .btn-primary {
    background-color: #0195F7;
  }


  .coverPic {
    object-fit: cover;
    /* height: 220px;
    width: 385px; */
    width: 100%;
    /* height: auto; */
  }

  .videoView {
    object-fit: cover;
    height: 425px;
    width: 425px;
    cursor: pointer;
  }

  .previewImg {
    object-fit: cover;
    /* height: 425px;
    width: 360px; */
    width: 100%;
    height: auto;
  }

  .Map_Place_Thumb_Photo {
    object-fit: cover;
    width: 128px;
    height: 120px;
  }

  .Map_Place_Photo_Url {
    object-fit: cover;
    width: 259px;
    height: 120px;
    margin-left: -24px;
  }

  .explurgen-with-media .imageView {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }

  .profilePic {
    object-fit: cover;
    height: 425px;
    width: 383px;
  }

  .playIcon {
    height: 50px;
    position: absolute;
    margin-left: 10rem;
    margin-top: 13rem;
    cursor: pointer !important;
    opacity: 80%;
  }

  .footer-left-inner1 {
    width: 35%;
    margin-top: 0px;
    text-align: center;
    position: relative;
    float: left;
  }

  .footer-left-inner2 {
    width: 30%;
    margin-top: 0px;
    text-align: center;
    position: relative;
    float: left;
  }

  .footer-left-inner3 {
    width: 35%;
    margin-top: 0px;
    text-align: center;
    position: relative;
    float: left;
  }
  .footer-left-inner4 {
    width: 45%;
    margin-top: 0px;
    text-align: left;
    position: relative;
    float: left;
    padding: 0 5px;
  }
  .footer-left-inner5 {
    width: 55%;
    margin-top: 0px;
    text-align: right;
    position: relative;
    float: right;
    padding: 0 5px;
  }

  /* .header {
    position: fixed;
    z-index: 999;
    height: 61px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 34px;
    background-color: #FDFFFD;
  } */

  .top-section {
    background: #FDFFFD;
    position: fixed;
    position: fixed;
    z-index: 999;
    padding-bottom: -28px;
    height: 60px;
  }

  .header-data {
    display: flex;
    margin-top: 8px;
  }

  .logoImg {
    height: 40.83px;
    width: 78.38px;
  }

  .openAppBtn {
    border-radius: 25px;
    background-color: #D9D9D9;
  }

  .openAppBtn:hover{
    background-color: #D9D9D9;
  }

  .fade {
    background-color: #05040482;
  }

  .seeTheFullProfileInAppModalDialog {
    /* margin-top: 573px; */
    width: 100%;
    /* margin-left: 0px; */
    position: fixed;
    top: auto;
    right: auto;
    left: auto;
    bottom: -57.5px;
  }

  .seeTheFullProfileInAppModalDialog.midSeeMorePopup {
    max-width: 330px;
  }

  .modal-content {
    background-color: #F9F9F9;
  }

  .getTheApp {
    /* width: 374px;
    height: 50px;
    top: 783px;
    left: 20px;
    margin-left: -10px; */
    border-radius: 30px;
    width: 100%;
    /* height: 50px; */
    background: #0195F7;
    color: #FFFFFF;
  }

  .modelTitle {
    /* font-family: SF Pro Text; */
    font-size: 14px;
    font-weight: 600;
    line-height: 0px;
    letter-spacing: -0.40799999237060547px;
    text-align: center;
    color: #000000;
  }

  .modelDesc {
    /* font-family: SF Pro Text; */
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.07800000160932541px;
    text-align: center;
    color: #000000;
    opacity: 87%;
  }

  .bottom-modelTitle {
    /* font-family: SF Pro; */
    font-size: 21px;
    font-weight: 590;
    line-height: 22px;
    text-align: center;
    color: #000000;
  }

  .bottom-modelDesc {
    /* font-family: SF Pro; */
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.4099999964237213px;
    text-align: center;
    color: #000000;
    opacity: 87%;
  }

  /* .bottom-modelDesc #b {
    font-family: SF Pro;
    font-size: 14px;
    font-weight: 510;
    line-height: 12px;
    letter-spacing: -0.4099999964237213px;
    text-align: center;
  } */



  .getTheAppCenetr {
    /* width: 374px;
    height: 50px; */
    top: 783px;
    left: 20px;
    border-radius: 30px;
    /* margin-left: -10px; */
    width: 230px;
    height: 40px;
    background: #0195F7;
    color: #FFFFFF;
  }

  /* .postWoner {
    border-top: 1px solid #ccc;
    margin-top: 12px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  } */

  .modalUserProfile {
    /* left: 50%; */
    margin: -33px 0px 0px 0px;
  }

  .modalUserProfileCenter {
    /* left: 50%; */
    margin: -33px 0px 0px 0px;
  }

/*
  .image_profile_post {
    width: 385px;
    height: 385px;
    padding-top: 0px;
    margin-left: 0px;
  }
*/
}

.modalUserProfile {
  /* left: 50%; */
  margin: -57px 0px 0px 0px;
}

.modalUserProfileCenter {
  /* left: 50%; */
  margin: -57px 0px 0px 0px;
}

.fade.modal.show  {
  padding: 0px !important;
}
.img_data_modal {
  /* width: 15%; */
  position: relative;
  /* float: left; */
  padding: 10px 0px; 
}
.dontMissModal {
  z-index: 9999;
}
.seeTheFullProfileInAppModalDialog .getTheApp {
  font-weight: normal;
  margin: 0 auto;
}
/* desktop version */
@media (min-width: 992px) {
  .dontMissModalDialog, .seeTheFullProfileInAppModalDialog.midSeeMorePopup {
    max-width: 330px;
  }

  .seeTheFullProfileInAppModalDialog {
    max-width: 428px;
  }
  
  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,
  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{
    /* width: 33.3%;
    left: 33.3%; */
    max-width: 428px;
    /* margin: 0 40px; */
  }  

  .max428 {
    max-width: 428px;
  }
  .m040{
    /* margin: 0 40px; */
  }
  
}


/* left: 36%;
width: 28%; */

@media (min-width: 1024px) {
  .m040{
    margin: 0px;
  }
  .dontMissModalDialog {
    /* left: 36%;
    width: 26%; */
  }
  .seeTheFullProfileInAppModalDialog {
    /* width: 33.3%;
    left: 33.3%; */
  }  
  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,
  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{

  }   
}
@media (min-width: 1024px) {

  .dontMissModalDialog {
    /* left: 36%;
    width: 28%; */
  }

  .sticky-div {
    width: 33.33333%;
  }  
}


@media (min-width: 1440px) {
  .m040{
    margin: 0px 24px;
  }
  .dontMissModalDialog {
    /* left: 36.4%;
    width: 27%; */
    /* left: 38.5%;
    width: 23%; */
  }
  .seeTheFullProfileInAppModalDialog {
    /* left: 34.9%; */
    width:auto;
  }  
  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,
  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{
    /* left: 34.9%; */
  }   
}

@media (min-width: 1536px) {
  .dontMissModalDialog {

    /* left: 37.5%;
    width: 23%; */
  }
}

@media (min-width: 2560px) {
  .m040{
    margin: 0px 214px;
  }
  .dontMissModalDialog {
    /* width: 15.3%;
    left: 42.4%; */
  }
  .seeTheFullProfileInAppModalDialog {
    /* left: 41.7%; */
  }  
  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,
  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{
    /* left: 41.7%; */
  }   
}

.dontMissModalDialog .modal-content,
.seeTheFullProfileInAppModalDialog .modal-content {
  background-color: #FFF !important;
  border: none !important;
  border-radius: 20px;
}

.seeTheFullProfileInAppModalDialog.showInBottomContinueWebsite{
  min-height: 40%;
    background: #fff;
    border-radius: 20px 20px 0 0;
}

.seeTheFullProfileInAppModalDialog.showInBottomContinueWebsite .modal-content {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.data-match-dot-dot {
  /* width: 27px; */
  padding: 25px 0px;
  float: right;
  display: flex;
  justify-content: end;
}
.data-match-dot-dot>span {
  height: 5px;
  width: 5px;
  background-color: #2d97f7;
  border-radius: 50%;
  display: inline-block;
  margin: 0px 2px 0px 0px;
}

.data-match-dot-dot {
  width: 27px;
  padding: 25px 0px;
  float: right;
  display: flex;
  justify-content: end;
}

span.time-dot {
  height: 4px;
  width: 4px;
  background-color: gray;
  border-radius: 50%;
  display: inline-block;
  margin: 2px 8px;
}

.postTextView .postText a:link,
.postTextView .postText a:visited,
.postTextView .postText a:hover,
.postTextView .postText a:active{ 
  text-decoration: none; 
} 

@media (max-width: 424px) {
  .data-match-dot-dot {
    width: 23px;
  }
}

@media (max-width: 374px) {
  .data-match-dot-dot {
    width: 20px;
  }
}
@media (min-width: 768px) {
  .data-match-dot-dot {
    width: 22px;
  }
}

.postMedia {
  /* border-bottom: 1px solid gainsboro; */
}

.linkPreviewRightBoxContainer{
  display: table;
  width: 100%;
}

.linkPreviewLeftBox {
  width: 40%;
  padding: 0px;
  display: table-cell;
}

.linkPreviewRightBox {
  width: 60%;
  padding: 0px;
  background: lightgrey;
  display: table-cell;
  vertical-align: middle;
  margin: auto;
}

.linkPreviewRightBox .linkPreviewRightBox2 {
  /* vertical-align: middle;
  margin: auto; */
  padding: 0px 5px;
}
.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 {
  /* vertical-align: middle;
  margin: auto; */
}

.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 a:link,
.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 a:visited,
.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 a:hover,
.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 a:active {
  color: black;
  text-decoration:none;
}
/* @media (max-width: 424px) {
  .data-match-dot-dot {
    width: 23px;
  }
} */

/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {
  /* For portrait layouts only */
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {
  /* For landscape layouts only */
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1023px){
  .p0170 {
    margin: 0px 170px !important;
  }
  .dontMissModalDialog.p0170 {
    /* margin: 0px 150px !important; */
  }

  .seeTheFullProfileInAppModalDialog .modal-content {
    width: 425px;
  }

  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,
  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{
    width: 428px;
  }  

  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,
  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{
    /* margin: 0px 170px !important; */
  }

  .dontMissModalDialog .modal-content {
    width: 360px;
  }

  .dontMissModalDialog {    
    /* left: 7%; */
  }

}

@media screen and (min-width: 1400px) {
  .postCard {
    width: 850px;
  }
  .postCard2 {
    width: 850px;
  }
  .postCard3 {
    width: 850px;
  }
}


.modal-dialog.modal-dialog-centered .imageViewBoxFullScreen {
  /* width: 100% !important; */
  /* height: 100% !important; */
}

.modal-dialog.modal-dialog-centered .imageViewBox {
  /* width: 100% !important; */
  /* height: 100% !important; */
}
/* #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content .imageViewBox */

#PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content .imageViewBoxFullScreen
#PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content .imageViewBoxFullScreen {
  width: 100% !important;
  /* left: 33.3%; */
}


.modal-dialog.modal-dialog-centered {
  margin: 0px;
}

.modal-dialog.modal-dialog-centered .modal-header {
  width: 30px;
  height: 30px;
  border: 0;
  position: absolute;
  z-index: 1;
  /* top: -7px; */
  /* left: -20px; */
  padding: 0px;
}

.modal-dialog.modal-dialog-centered .img_container1 img, 
.modal-dialog.modal-dialog-centered .img_container2 img, 
.modal-dialog.modal-dialog-centered .imageViewBox img,
.modal-dialog.modal-dialog-centered .imageViewBox2 img, 
.modal-dialog.modal-dialog-centered .imageViewBox3Single img, 
.modal-dialog.modal-dialog-centered .imageViewBox225 img,
.modal-dialog.modal-dialog-centered .videoExplrView img
{
  object-fit: contain;
}

.modal-dialog.modal-dialog-centered .videoExplrView .startPlayIcon {
  left: 60%;
}

.modal-dialog.modal-dialog-centered .modal-header button
{
  /* background-color: gray; */
  /* height: 0px; */
  /* padding: 3px;
  left: -2px; */
  position: relative;
  top: 7px;
  /* width: 2em;
  height: 2em; */
}

.modal-dialog.modal-dialog-centered .videoViewCount {
  float: right;
  position: absolute;
  border-bottom-right-radius: initial;
  border-bottom-left-radius: 20%;
  right: 6px;
}

.modal {
  --bs-modal-width: 100% !important;
}

.btn-close {
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
  opacity: 1;
}

/*
.lds-ellipsis 
*/

.scroll-div  #ptr-parent #ptr-pull-down #container .sk-fading-circle
{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
  background-size: contain;
  background-position: center;
  width: 1.5em !important;
  background-repeat: no-repeat;
  display: block;
}

.sk-fading-circle .sk-circle {
  display: none !important;
}

.p010{
  padding: 0px 10px;
}

.postWoner .data-match {
  width: 85%;
}

.bbtm {
  border-bottom: .4px solid #cccccc;
}

.bt {
  border-top: .4px solid #cccccc;
}

.postText .text {
  margin-bottom: 0px;
}

.read-or-hide {
  color: #2d97f7 !important;
}

.profile-pic-post-row.imageViewBox {
  /* filter: blur(20px); */
  /* background-size: cover; */
  /* opacity: .3; */
}

.profile-pic-post-row2.polygonBox {
  position: absolute;
  top: 0px;
}
.b1lg {
  border: .4px solid #cccccc;
}


.BoxPostWoner2  .profile-pic-post-row2.polygonBox {
  bottom: 0px;
  top: auto;
}

.kudoVal2 {
  float: left;
  margin-left: 3px;
}

.spreadVal2 {
  float: right;
  margin-right: 10px;
}
@media screen and (max-width: 425px) {
  .kudoVal {
    margin-left: -10px;
  }
  .kudo-count-container {
    margin-left: 10px;
  }
  .footer-left-inner4 {
    width: 44%;
    padding: 0 5px;
  }
  .footer-left-inner5 {
    width: 56%;
    padding: 0 5px;
  }
  .kudo-mark {
    margin-right: 0px;
  }
}

.splashScreen img {
  text-align: center;
  width: -webkit-fill-available;
}

.no_explurge_yet {
    justify-content: center;
    display: flex;
    /* padding: 20px 0; */
    text-align: center;
}
.no_explurge_yet div {
   padding: 5px 0px;
}

.profile-img-box {
  min-height: 180px;
  max-height: 180px; 
}

.profile-img {
  max-width: inherit;
  min-height: 180px;
  max-height: 180px;
  width: -webkit-fill-available;
}
.mt10 {
  margin-top: 10px;
}
.mtb10 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.mtminus60 {
  margin-top: -80px;
}
.Level_Icon_Profile {
  border: 1px solid lightgray;
  /* padding: 5px 10px; */
  /* margin: 10px 10px; */
  background-color: white;
  /* display: inline-block; */
  /* position: relative; */
  /* top: 25px; */
  border-radius: 15%;
  /* right: -10px; */
  width: 80px;
}

.postCardMP{
  margin-top: -10px;
  padding: 0px;
}

.Level_Icon_Profile_Text {
  justify-content: center;
  display: flex;
  /* right: -10px; */
  position: relative;
  color: #2d97f7;
  font-size: 14px;
  text-align: center;
}

.explr-col-3 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.explr-col-31 {
  flex: 0 0 auto;
  width: 34.33333333%;
}
.explr-col-32 {
  flex: 0 0 auto;
  width: 30.2%;
}
.ExplurgedLevelIconViewProfileBox {
  right: -10px;
  position: relative;
}

.ExplurgedLevelIconViewProfile {
  display: flex;
  justify-content: center;
  margin: 30px 0px 0px;
}

.explr-profile .image_profile {

}

.p10 {
  padding: 10px;
}

.p15Z{
  padding: 0px 15px;
  top: -15px;
  position: relative;
}

.mapProfileMapBox {
  width: 8%;
}

.mapProfileSummeryBox {
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: #2d97f7;
  /* width: 90%; */
  align-items: center;
}

.profile-summary-box {
  /* min-height: 230px; */
  margin: 10px 0px 0px;
  width: inherit;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;  
}

.profile-hex-box2 {
  position: relative;
  left: 12%;
}

.profile-summary-box-list-2 {
  top: -10px;
  position: relative;
}
.p2010 {
  padding: 20px 20px;
}

.profile-summary-place-img {
  top: 50px;
  position: absolute;
}

.profile-summary-place-jpg {
  width: inherit;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.block-box-summary {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.block-box-post {
  border-radius: 0px;
}

.m10px0 {
  margin: 10px 0px;
}

.postSummeryBox {
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: #2d97f7;
  width: 100%;
  align-items: center;
}

.link-color a {
  color: #2d97f7 !important;
}

.bucketUsers1 {
  width: 20%;
  float: left;
  padding-top: 8px;
}

.bucketTest {
  width: 40%;
  float: left;  
  justify-content: center;
  display: flex;
  vertical-align: middle;
  position: relative;
  align-items: center;
}

@media screen and (max-width: 425px) {
  .bucketTest {
    /* margin-top: -8px; */
  }
}

@media screen and (min-width: 1024px) and (max-width: 1270px) {
  .bucketTest {
    /* margin-top: -8px; */
  }
}

@media screen and (min-width: 425px) and (max-width: 768px) {
  .bucketTest {
    width: auto;
  }
}

@media screen and (min-width: 1440px) and (max-width: 2560px) {
  .bucketTest {
    width: auto;
  }
}

.profileButtonsBox {
  justify-content: center;
  align-items: center;
  display: flex;
  vertical-align: middle;
  position: relative;
}

.profileButtonsBoxInner {
  position: relative;
  align-items: center;
  /* justify-content: center; */
  vertical-align: middle;
  display: flex;
}

.profileButtonsBoxInnerRight {
  position: relative;
  align-items: center;
  justify-content: right;
  vertical-align: middle;
  display: flex;
}

.profileButtons {
  border-radius: 25px;
  width: auto;
  background-color: #0d6efd !important;
  /* padding: 3px; */
}


.profileButtonsFollow {
  /* width: 100px; */
  background-color: #0d6efd !important;
}

.profileButtonsMessage {
  /* width: 90px; */
  background-color: #D9D9D9 !important;
  color: black !important;
  border: none;
}

.profileButtonsShare {
  /* width: 50px; */
  background-color: #D9D9D9 !important;
  /* padding: 5px; */
  color: black !important;
  border: none;
}

.mzz10{
  margin: 0px 0px 10px;
}

.m5Z{
  margin: 5px 0px;
}

.fs16B {
  font-size: 16px;
  font-weight: bold;
  color: black;
}

.fs14N {
  font-size: 14px;
  font-weight: normal;
  color: #666;
}


.mtminus60 {
  /* margin-top: -80px; */
}

@media screen and (max-width: 768px) {
  .ExplurgedLevelIconViewProfile {
    margin: 30px 0px 0px;
  }
  .mtminus60 {
    margin-top: -85px;
  }  
  .profileButtonsFollow {
    width: 100px;
  }
}

@media screen and (max-width: 375px) {
  .mtminus60 {
    margin-top: -75px;
  }

  .Level_Icon_Profile {
    width: 60px;
  }
}

@media screen and (min-width: 768px) {
  .ExplurgedLevelIconViewProfile {
    /* margin: 20px 0 0; */
  }
  .mtminus60 {
    margin-top: -90px;
  }
  .profileButtonsBoxInnerRight {
    /* justify-content: center; */
  }
}

@media screen and (min-width: 1024px) {
  .ExplurgedLevelIconViewProfile {
    margin: 20px 0px 0px;
  }
  .mtminus60 {
    margin-top: -75px;
  }
}

@media screen and (min-width: 1440px) {
  .ExplurgedLevelIconViewProfile {
    margin: 30px 0px 0px;
  }
  .mtminus60 {
    margin-top: -85px;
  }
}


@media screen and (min-width: 1024px) and (max-width: 1024px){
  .ExplurgedLevelIconViewProfile {
    margin: 30px 0px 0px;
  }
  .Level_Icon_Profile {
    width: 65px;
  }
}

.bucketTest .btn-bucket-center{
  padding-left: 0px;
}

.summary-hex-count {
  font-size: 16px;
  font-weight: bold;
}
.summary-hex-text {
  font-size: 13px;
  font-weight: bold;
}

.welcomeBox {
  padding: 10px 0px 0px;
}

#webpack-dev-server-client-overlay {
  display: none !important;
}
.scroll-div .loaderbox{
  padding-top: 20px;
}
.post-view-list .loaderbox{
  margin: 20px;
}
#staticContinueWebsiteBox,
#dontMissModalBox,
#staticBackdropBox{
  /* width: 100vw;
  height: 100vh; */
}

/* new UI chnages 08-08-2025 */

.circle_profile400 {
  width: 100%;
  height: auto;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
  padding: 10px;
}
.circle_profile {
  width: 100px;
  height: 100px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_xsmall {
  width: 25px;
  height: 25px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_small {
  width: 50px;
  height: 50px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_medium {
  width: 70px;
  height: 70px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_large {
  width: 120px;
  height: 120px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_large130 {
  width: 130px;
  height: 130px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_xlarge {
  width: 150px;
  height: 150px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_xxlarge {
  width: 200px;
  height: 200px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_xxxlarge {
  width: 250px;
  height: 250px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}
.circle_profile_xxxxlarge {
  width: 300px;
  height: 300px;
  object-fit: cover;   /* keeps aspect ratio, fills space */
  border-radius: 50%;  /* makes it a perfect circle */
}

.profile-pic-post-row2.polygonBox {
  /* top: 0px; */
  top: 10px;
}

#dontMissModalBox .modalUserProfileCenter {
  display: contents;
}

.imageViewBox3Single img {
  /* max-height: 100%; */
  max-height: 425px;
}

.block-box {
  border-radius: 0px;
  margin-top: 1px;
}


.post-user-names-box {
  margin-top: 10px;
}

.post-user-names-box
.kudo-count-container {
    display: flex;
    align-items: center;
}
.post-user-names-box
.kudo-user-names {
    display: flex;
    align-items: center; 
    gap: 8px; 
}
.post-user-names-box
.kudo-user-names .kudosUserPics {
    display: flex;
    align-items: center; 
    margin-left: 10px;
}
.post-user-names-box
.kudo-user-names div img {
    display: flex;
    align-items: center;
    margin-left: -10px;
}
.post-user-names-box
.kudo-user-names > div:first-child {
    display: flex;
    align-items: center; 
    gap: 4px;
}

.post-user-names-box
.names1-names2 {
    display: flex;
    align-items: center;
    gap: 4px;
}

.footer-post-kudos-view-box
  .footer-post-kudos-container {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 15px;
  }

.footer-post-kudos-view-box
  .footer-post-kudos-container
  p {
    float: left;    
    margin: 0;
    /* padding: 8px; */
    white-space: nowrap;    
  }

/* Last column: fixed width */
.footer-post-kudos-view-box
.footer-post-kudos-container p.text-right {
    margin-left: auto;
    text-align: right;
    margin-right: 10px;
}

/* First 3: shrink-to-fit content */
.footer-post-kudos-view-box
.footer-post-kudos-container p:not(.text-right) {
    /* flex: 0 0 auto;  */
    /* size based on content */
}  

.footer-post-kudos-view-box
.footer-post-kudos-container p
img.kudimage {
    width: 22px;
    height: 25px;
    padding: 2px;
}

.footer-post-kudos-view-box
.footer-post-kudos-container p
img.saysimage {
    width: 25px;
    height: 25px;
    padding: 2px;
}

.footer-post-kudos-view-box
.footer-post-kudos-container p
img.spreadimage {
    width: 25px;
    height: 25px;
    padding: 2px;
}

.data-match-dot-dot {
    /* width: 27px; */
    padding: 20px 0px;
    float: right;
    display: flex;
    flex-direction: column;  /* vertical stack */
    align-items: end;     /* center horizontally */
    justify-content: flex-start; /* stick to top */
}

.data-match-dot-dot > span {
    height: 5px;
    width: 5px;
    background-color: #000; /* #2d97f7 */
    border-radius: 50%;
    display: inline-block;
    margin: 2px 0; /* vertical spacing */
}

.block-box.post-box
.postString {
  margin-left: 0px;
}

.block-box.post-box
.img_data {
  padding: 20px 0 0;
}
.block-box.post-box
.data-match
.data_left
{
  float: none;
}

.block-box.post-box
.data-match {
  padding: 20px 0px 0;
}


.b1l_t {
  border-top: .4px solid #cccccc;
}


.Circle_Level_Icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    position: absolute;
    right: 0px;
    background-color: rgb(120 113 113 / 40%);
    margin: 10px;
}

.Circle_Level_Icon .Level_Icon2 {
    height: 40px;
    position: absolute;
    z-index: 999;
    margin: 5px 20%;
}
/********journey_so_for*********/
    .stats-card {
      background: #f9f9f9;
      border-radius: 15px;
      padding: 5px;
      text-align: center;
      box-shadow: 0px 2px 6px #00000040;
      transition: transform 0.2s ease-in-out;
      cursor: pointer;
  
    }
    .stats-card:hover {
      transform: translateY(-3px);
    }
    .stats-icon {
      /* font-size: 2rem; */
      /* margin-bottom: 10px; */
      color: #4CAF50;
      text-align: left;
    }
    .stats-value {
      font-size: 1.5rem;
      font-weight: bold;
      text-align: right;
    }
    .stats-label {
      font-size: 0.75rem;
      color: #555;
      text-align: right;
    }

/* element.style {
    text-align: right;
}     */

.profile-summary-place-img {
    top: inherit;
}

.journey_so_for_image {
  width: 25px;    
  height: 25px;
  margin: 5px 0px;
}

.journey_so_for_image.miles {
    margin: 5px 0px;
    width: 16px;
    height: auto;
}

/*****will-go-to****/

.Will-Go-To-Box {
  background-color: gainsboro;
}

.will-go-to-month-day {
    background-color: #413a3a;
    white-space: break-spaces;
    padding: 3px;
    color: wheat;
    margin: 0 2px;
}

.m5Z {
    margin: 1px 0px;
}
.Level_Icon_Profile {
  width: 65px;
}

.circle_profile_large130 {
  width: 108px;
  height: 108px;
}

.ExplurgedLevelIconViewProfile {
    justify-content: end;
    text-align: right;
}

.Level_Icon_Profile_Text {
    /* justify-content: end;
    text-align: right; */
}

.profileButtonsFollow,
.profileButtonsMessage,
.profileButtonsShare {
  width: 100%;
}

.profileButtonsFollow {
  background-color: #0195F7 !important;
}

.profile-pic-post-row2.polygonBox {
    top: 0px;
    /* top: 10px; */
}

.bucketTest .btn-bucket-center {
    margin-top: 0px;
    display: flex;
    align-items: center;   /* Vertical align */
    justify-content: center;
    min-height: 35px;
    max-height: 35px;
}

.bucketTest .btn-bucket-center b {
  padding: 0 3px;
  display: contents;
}
.explurgen-with-media
.flex-parent
.Map_Photo_Box img.Map_Photo_Img {
  /* object-fit: cover; */
}


.bucketTest {
    width: 50%;
    justify-content: start;
}

.profile-img {
    min-height: 150px;
    max-height: 150px;
}

.circle_profile_large130 {
    width: 100px;
    height: 100px;
    border: 2px solid white;
}

    .mtminus60 {
        margin-top: -100px;
    }

    .ExplurgedLevelIconViewProfile {
        margin: 25px 0px 0px;
    }

body.modal-open {
  /* position: fixed;
  width: 100%; */
  overflow: hidden;
}



@media (max-width: 424px) {
  .block-box.post-box .data-match {
    padding: 20px 0 0 10px;
  }
}

#staticContinueWebsite,
#staticContinueWebsiteBox,
#staticBackdrop,
#dontMissModalBox,
#staticBackdropBox {
  position: fixed;
  width: 100%;
  height: 100%;
  height: 100vh;   
  /* fallback */
  height: 100dvh;  
  /* modern Safari overrides */
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0;   /* override */
  margin-bottom: 0;    /* override */  
  z-index: 9999;
}

#staticContinueWebsiteBox,
#staticBackdropBox
.modal-backdrop {
  width: 100%;
  height: 100%;
  height: 100dvh;  

  padding-bottom: 0;   /* override */
  margin-bottom: 0;    /* override */  
}

@media (min-width: 1024px) {
  .sticky-div {
    width: 428px;
    /* max-width: 100%; */
  }  
}

@media (min-width: 428px) {
  .sticky-div {
    /* width: 428px; */
    max-width: 100%;
  }  
}

    /* Sticky header */
    header.sticky_top_header {
      position: sticky;
      top: 0;
      z-index: 1000;
      background: #fff;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
      padding: 0 10px;
    }

    header.sticky_top_header .header-inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
    }

    header.sticky_top_header .header-logo {
      max-height: 40px;
    }

    header.sticky_top_header .top_container.container {
        margin-top: auto;
        padding-left: auto;
        margin-left: auto;
        z-index: 1000;
        padding-right: auto;
    }
   

    @media (min-width: 992px) {
        header.sticky_top_header .top_container {
            max-width: 525px;
        }
    }

    @media (min-width: 1200px) {
      header.sticky_top_header .top_container {
        max-width: 800px;
      }
    }    

.post-user-names-box
.names1-names2 div {
  float: left;
}


@media (max-width: 320px) {
  .bucketTest .btn-bucket-center {
    /* font-size: smaller; */
    font-size: 10px;
  }
  .AddbucketListBtn {
    width: 88px;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1024px) {
    .scroll-div
    .p0170 {
        margin: unset !important;
    }
    .max428 {
        width: 35%;
    }
    /* 
    .dontMissModalDialog {
        left: 21%;
    }

    .seeTheFullProfileInAppModalDialog {
        left: 12%;
    }     
    */
    
}


.profile-img-box-image {
    min-height: 150px;
    max-height: 150px;
}

.post-box .img_data .circle_profile_small {
  width: 40px;
  height: 40px;
}

.Circle_Level_Icon {
    width: 45px;
    height: 45px;
}

.Circle_Level_Icon .Level_Icon2 {
    height: 35px;
}

.circle_profile400 {
    padding: unset;
    border: 1px solid white;
}

.profile-pic-post-row2.polygonBox {
  padding: 10px;
}

.link-color a{
  text-decoration: none;
}

.main_container,
.seeTheFullProfileInAppModalDialog ,
.dontMissModalDialog {
    display: flex;
    justify-content: center;
    align-items: center;
}
#staticContinueWebsiteBox #staticContinueWebsite.modal.staticContinueWebsite,
#dontMissModalBox #dontMissModal.modal.dontMissModal,
#staticBackdropBox #staticBackdrop.modal.staticBackdrop {
    display: flex;
    justify-content: center;
    align-items: center;  
}

#PostInFullScreenVerticallyCenteredModal,
#PostInFullScreenVerticallyCenteredModal2 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-dialog.seeTheFullProfileInAppModalDialog.showInBottomContinueWebsite {
    position: fixed;
    bottom: 0 !important;
    margin: 0 !important;
    margin-bottom: -5px !important;
    width: 100%;
}

/* .block-box.post-box .postCard .img_data, */
.block-box.post-box .postCard2 .img_data {
    width: 13%;
}

.w50p {
  width: 50%;
}

.pd05 {
  padding: 0px 5px;
}

.btn-bucket-center {
    color: #000;
}

.profile-img {
  width: -moz-available;
  object-fit: cover;
}

.splashScreen img {
  width: -moz-available;
}

.no_explurge_yet .header-logo {
    max-height: 100px;
}

.link-secondary {
  text-decoration: none;
}

@media (min-width: 1200px) {
  .main_container
  .no_explurge_yet 
  .display-6 {
      font-size: 2.0rem;
  }
}
.main_container
.no_explurge_yet 
.fs-5 {
    font-size: 1.10rem !important;
}

/* For small screens only */
@media screen and (max-width: 767px) {
  .seeTheFullProfileInAppModalDialog {
    bottom: 25px;
  }
}

.modal-dialog.seeTheFullProfileInAppModalDialog {
  bottom: auto !important;
}


.profileButtonsOpenAppBtn {
  width: auto !important;
}

#PostInFullScreenVerticallyCenteredModal2,
#PostInFullScreenVerticallyCenteredModal {
  align-items: flex-start;
}

.videoExplrView > div[data-vjs-player="true"] > div[webkit-playsinline="true"]{
    justify-content: center;
    display: flex;
}


/* Ensure modal is truly full-screen and centered */
/* Ensure modal dialog is perfectly centered and full-width */
.custom-modal-dialog {
  margin: 0 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  position: fixed !important;
}

body.modal-open {
  padding-right: 0 !important;
}



/* Slide back down when closing */
#staticContinueWebsiteBox
.modal.fade:not(.show) .modal-dialog {
  transform: translateY(100vh);  
}


.circle_profile_small_continue {
  width: 83px;
  height: 83px;
}


.modalUserProfileContinue{
  margin: 0px;
}

.txt-continue-head{
  font-weight: bold;
  font-size: 21px;
  margin-bottom: 0;

}

.txt-continue-desc {
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 25px;
}

.circle_profile_small {
    width: 83px;
    height: 83px;
    border: 1px solid #D3D3D3;
}

.modalUserProfile {
    margin: 2px 0 7px 0;
}

.openInApp {
  margin-bottom: 15px;
}

.closeBtnModal {
  position: fixed;
  top: 12px;
  right: 12px;
  cursor: pointer;
  z-index: 9999;
}

.pageNotFoundCloseIcon {
  right: 10px;
}

.closeIconStyle {
  width: 27px;
  cursor: pointer;
}

.max-width-80-per{
  max-width: 80%;
}

.want-to-engage-txt {
  font-family: 'SF Pro Light';
  font-size: 21px;
  line-height: 25px;
  margin-bottom: 11px;
}
.open-the-app-to-connect{
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 25px;
}

#dontMissModalBox .modal-backdrop, #staticBackdropBox .modal-backdrop {
  background-color: #000000;
    opacity: 0.65;
}

.post-item {
  position: relative;
}

.post-bottom-sentinel {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 1px;
  pointer-events: none;
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAEA;IACI,qBAAqB;IACrB;8DACqE;IACrE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B;8DACmE;IACnE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,2DAAoE;AACxE;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,oEAAoE;EACpE,wBAAwB;;EAExB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,MAAM;EACN,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,gCAAgC;EAChC,gCAAgC;EAChC,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,SAAS;EACT,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;;AAE1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB;AACF;;;;AAIA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;;EAEZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB;;6BAE2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EAEzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;iBACe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;;AAEf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;;AAEZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;AACA;;;;;CAKC;;AAED;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;;AAEpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,sCAAsC;;AAEtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;;EAEhB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;;;;;;;;;;;;;MAaM;;AAEN;;;;;;;GAOG;AACH;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;;AAEb;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,cAAc;EAChB;EACA;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,iBAAiB;;AAEnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,iBAAiB;;AAEnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,iBAAiB;;AAEnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;;EAEf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;;AAEf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,UAAU;;AAEZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;;AAEjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;;AAErB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,YAAY;;AAEd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;;AAEb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,uBAAuB;;AAEzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;;oBAEkB;EAClB,cAAc;;AAEhB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;;;AAGjC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,iBAAiB;;AAEnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;;;AAIA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;;AAEnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;;AAEnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;;;AAGnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;;AAEnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB;iBACe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB;iBACe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB;gBACc;EACd,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB;gBACc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,cAAc;;AAEhB;;AAEA;EACE,iBAAiB;EACjB;gBACc;AAChB;AACA;EACE,iBAAiB;EACjB;gBACc;AAChB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B;kBACgB;AAClB;;AAEA;EACE,iBAAiB;EACjB;gBACc;AAChB;;AAEA;EACE,iBAAiB;EACjB;gBACc;AAChB;;AAEA;EACE,iBAAiB;EACjB;iBACe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;;;;AAKA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;;AAGA;EACE,eAAe;AACjB;;AAEA;;;;GAIG;;AAEH;EACE,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;GAMG;;;AAGH;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B;aACW;EACX,uBAAuB;;EAEvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,YAAY;AACd;;AAEA;;;;;GAKG;;AAEH;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU,EAAE,uCAAuC;EACnD,sDAAsD;EACtD,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU,EAAE,uCAAuC;EACnD,sDAAsD;EACtD,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf;;eAEa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE;;qBAEmB;EACnB,eAAe;EACf;;aAEW;EACX,UAAU;AACZ;;AAEA,0EAA0E;AAC1E;EACE;;KAEG;;EAEH;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,iBAAiB;IACjB;mBACe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB;mBACe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,cAAc;EAChB;EACA;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,cAAc;EAChB;;EAEA;;;;;;;;KAQG;;EAEH;IACE,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;;;;yBAIqB;IACrB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;IAClB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,YAAY;EACd;;EAEA;;;;;;;KAOG;;;;EAIH;IACE;mBACe;IACf,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;;;;KAKG;;EAEH;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;AAEF;;;;;;;CAOC;AACD;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,oBAAoB;AACpB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE;kBACc;IACd,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;;AAEF;;;AAGA;aACa;;AAEb;EACE;IACE,WAAW;EACb;EACA;IACE;iBACa;EACf;EACA;IACE;kBACc;EAChB;EACA;;;EAGA;AACF;AACA;;EAEE;IACE;iBACa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,gBAAgB;EAClB;EACA;IACE;iBACa;IACb;iBACa;EACf;EACA;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE;iBACa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE;kBACc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;IACb,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;iBACe;EACf,gBAAgB;AAClB;AACA;EACE;iBACe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,oBAAoB;AACtB;AACA;;;;GAIG;;AAEH,4CAA4C;AAC5C;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;AAEF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;;AAGA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA,8GAA8G;;AAE9G;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,4BAA4B;EAC5B,iBAAiB;EACjB;eACa;EACb,kBAAkB;EAClB,QAAQ;EACR;gBACc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qEAAqE;EACrE,UAAU;AACZ;;AAEA;;CAEC;;AAED;;EAEE,oEAA8D;EAC9D,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;AACtB;AACA;GACG,gBAAgB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;AAEA;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;;;EAGE;kBACgB;AAClB;;AAEA,8BAA8B;;AAE9B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;EACnD,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,IAAI,oCAAoC;EACzD,kBAAkB,GAAG,8BAA8B;AACrD;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;AAEF;;;IAGI,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;AAEF,6BAA6B;AAC7B;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;;IAEI,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,sBAAsB,GAAG,mBAAmB;IAC5C,gBAAgB,MAAM,wBAAwB;IAC9C,2BAA2B,EAAE,iBAAiB;AAClD;;AAEA;IACI,WAAW;IACX,UAAU;IACV,sBAAsB,EAAE,YAAY;IACpC,kBAAkB;IAClB,qBAAqB;IACrB,aAAa,EAAE,qBAAqB;AACxC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;AACA;;;;EAIE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;;AAGA;EACE,8BAA8B;AAChC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;AACA,gCAAgC;IAC5B;MACE,mBAAmB;MACnB,mBAAmB;MACnB,YAAY;MACZ,kBAAkB;MAClB,iCAAiC;MACjC,sCAAsC;MACtC,eAAe;;IAEjB;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,qBAAqB;MACrB,yBAAyB;MACzB,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,iBAAiB;MACjB,iBAAiB;MACjB,iBAAiB;IACnB;IACA;MACE,kBAAkB;MAClB,WAAW;MACX,iBAAiB;IACnB;;AAEJ;;OAEO;;AAEP;IACI,YAAY;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,2BAA2B;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;AACA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;wBACoB;AACxB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;IACI,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB,IAAI,mBAAmB;IAC1C,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;;EAGE,uBAAuB;AACzB;;;AAGA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;AAEJ;EACE;gBACc;EACd,gBAAgB;AAClB;;;;AAIA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;;;;;EAKE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,IAAI,aAAa;EAClC,gBAAgB,KAAK,aAAa;EAClC,aAAa;AACf;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,cAAc;;EAEd,iBAAiB,IAAI,aAAa;EAClC,gBAAgB,KAAK,aAAa;AACpC;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;IAEI,kBAAkB;IAClB;MACE,gBAAgB;MAChB,MAAM;MACN,aAAa;MACb,gBAAgB;MAChB,wCAAwC;MACxC,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;QACjB,aAAa;QACb,mBAAmB;IACvB;;;IAGA;QACI;YACI,gBAAgB;QACpB;IACJ;;IAEA;MACE;QACE,gBAAgB;MAClB;IACF;;AAEJ;;EAEE,WAAW;AACb;;;AAGA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;;AAEA;IACI;;QAEI,wBAAwB;IAC5B;IACA;QACI,UAAU;IACd;IACA;;;;;;;;KAQC;;AAEL;;;AAGA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;IAGI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;;IAGI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,WAAW;AACf;;AAEA,6CAA6C;AAC7C;IACI,UAAU;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;MAGI,iBAAiB;EACrB;AACF;AACA;;;IAGI,6BAA6B;AACjC;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;;AAGA,mDAAmD;AACnD,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;;;AAIA,iCAAiC;AACjC;;EAEE,4BAA4B;AAC9B;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;IACvB,aAAa;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Open+Sans');\n\n@font-face {\n    font-family: 'SF Pro';\n    src: url('./assets/fonts/SFPro/SFProText-Regular.woff2') format('woff2'),\n        url('./assets/fonts/SFPro/SFProText-Regular.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'SF Pro Light';\n    src: url('./assets/fonts/SFPro/SFProText-Light.woff2') format('woff2'),\n        url('./assets/fonts/SFPro/SFProText-Light.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: normal;\n    src: url('./assets/fonts/Roboto/Roboto-Regular.woff') format('woff');\n}\n\nbody {\n  /* font-family: 'Open Sans', cursive; */\n  /* font-family: 'Roboto', cursive; */\n  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif;\n  background-color:#e8e8e8;\n\n  /* background-color:red; */\n  /* position: fixed; */\n}\n\n.row {\n  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.mob {\n  margin-left: 0px;\n}\n\n.row {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.mobdata {\n  position: relative;\n  align-items: left;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 15px;\n  vertical-align: top;\n}\n\n.hex {\n  width: 318px;\n  height: 318px;\n  margin: 50px auto;\n  position: relative;\n}\n\n.hex:before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 80px solid transparent;\n  border-top: 0px solid #F3F5F6;\n  border-left: 145px solid #F3F5F6;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n}\n\n.hex:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 80px solid transparent;\n  border-top: 0px solid #F3F5F6;\n  border-right: 145px solid #F3F5F6;\n  top: 0;\n  right: 0;\n  z-index: 9999;\n}\n\n.hex-title {\n  width: 105%;\n  height: 40px;\n  background: #005A87;\n  position: absolute;\n  margin: auto;\n  left: -2.5%;\n  top: 0;\n  bottom: 0;\n  z-index: 99999999999;\n  font-family: Arial;\n  font-size: 14px;\n  color: #fff;\n  line-height: 40px;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n\n.hex-img {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.hex-img img {\n  max-height: 100%;\n}\n\n.hex-hide {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.hex-hide:before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 80px solid transparent;\n  border-bottom: 0px solid #F3F5F6;\n  border-left: 145px solid #F3F5F6;\n  bottom: 0;\n  left: 0;\n  z-index: 9999;\n}\n\n.hex-hide:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 80px solid transparent;\n  border-bottom: 0px solid #F3F5F6;\n  border-right: 145px solid #F3F5F6;\n  bottom: 0;\n  right: 0;\n  z-index: 9999;\n}\n\n@viewport {\n  width: device-width;\n  /* width: min-content; */\n\n}\n\n.logo {\n  align-self: left;\n  margin-top: -10px;\n  z-index: 3;\n  margin-left: 86%;\n  opacity: 85%;\n  position: absolute;\n  filter: invert;\n  background-color: transparent;\n}\n\n.logo-spread {\n  align-self: left;\n  margin-top: 0px;\n  z-index: 3;\n  position: absolute;\n  margin-left: 145px;\n}\n\n.logo-will {\n  align-self: left;\n  margin-top: 15px;\n  z-index: 3;\n  position: absolute;\n  margin-left: 453px;\n}\n\n.hexdata {\n  position: relative;\n  vertical-align: top;\n  opacity: 0.5;\n  z-index: 2;\n}\n\n.hexdata1 {\n  text-align: right;\n  vertical-align: top;\n  margin-top: -25px\n}\n\n\n\n.smartphone_new {\n  background: white;\n  position: absolute;\n  min-height: 100%;\n  margin: auto;\n\n  margin-top: 10px;\n  margin-left: 80px;\n  border: 0px #cccccc solid;\n  align-items: center;\n  /* border-top-width: 60px;\n      border-bottom-width: 60px;\n      border-radius: 36px   */\n}\n\n.media {\n  width: auto;\n  height: 50rem;\n  object-fit: contain;\n}\n\n.slide_data {\n  vertical-align: top;\n}\n\n.react-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/******************************/\n.content {\n  text-align: left;\n}\n\n.content h1 {\n  font-family: 'Sansita', sans-serif;\n  letter-spacing: 1px;\n  font-size: 50px;\n  color: #282828;\n  margin-bottom: 10px;\n}\n\n.content i {\n  color: #FFC107;\n}\n\n.content span {\n  position: relative;\n  display: inline-block;\n}\n\n.content span:before,\n.content span:after {\n  position: absolute;\n  content: \"\";\n  background-color: #282828;\n  width: 20px;\n  height: 2px;\n  top: 40%;\n}\n\n.content span:before {\n  left: -5px;\n}\n\n.content span:after {\n  right: -45px;\n}\n\n.content p {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  letter-spacing: 1px;\n}\n\n.wrapper {\n  position: relative;\n  display: inline-block;\n  border: none;\n  font-size: 14px;\n  margin: 10px auto;\n  left: 10px;\n  transform: translateX(-50%);\n  width: auto;\n  height: auto;\n\n}\n\n.wrapper input {\n  border: 0;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  position: absolute !important;\n  clip: rect(1px 1px 1px 1px);\n  clip: rect(1px, 1px, 1px, 1px);\n  opacity: 0;\n}\n\n\n.wrapper label {\n  position: relative;\n  float: right;\n  color: #C8C8C8;\n}\n\n.wrapper label:before {\n  margin: 5px;\n  content: \"\\f005\";\n  font-family: FontAwesome;\n  display: inline-block;\n  font-size: 1.5em;\n  color: #ccc;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n.wrapper input:checked~label:before {\n  color: #FFC107;\n}\n\n.wrapper label:hover~label:before {\n  color: #ffdb70;\n}\n\n.wrapper label:hover:before {\n  color: #FFC107;\n}\n\n.kudimage {\n  /* margin-top: 3px; */\n  /* height: 25px; */\n  /* margin-left: -7px; */\n  padding: 2px;\n}\n\n.saysimage {\n  /* margin-top: 3px; */\n  /* height: 25px; */\n  /* margin-left: 5px; */\n  padding: 2px;\n}\n\n.spreadimage {\n  /* margin-top: 3px; */\n  /* height: 25px; */\n  /* margin-right: 10px; */\n  padding: 2px;\n}\n\n.say_image {\n  margin-top: 3px;\n  height: 20px;\n}\n\n.grayscale {\n  filter: grayscale(100%);\n  text-align: right;\n  flex: 2;\n  height: 20px;\n}\n\n.textdata {\n  margin-top: 15px;\n  position: relative;\n  float: left;\n  text-align: left;\n  word-wrap: break-word;\n}\n\n.caption_data {\n  line-height: 1em;\n  height: 2em;\n  overflow: hidden;\n  text-align: justify;\n  position: relative;\n  align-items: left;\n  margin-left: 0px;\n  margin-top: 10px;\n  padding-top: 0px;\n  padding-left: 0px;\n  word-wrap: break-word;\n  word-break: break-word;\n  height: auto;\n}\n\n.image_profile {\n  /* width: 45px;\n  height: 45px; */\n  padding-top: 0px;\n  margin-left: 0px;\n  align-self: left;\n  align-content: left;\n}\n\n.image_profile_spread {\n  width: 50px;\n  height: 60px;\n  padding-top: 5px;\n  padding-left: 0px;\n  margin-left: 23px;\n}\n\n.imagedata {\n  align-items: left;\n  max-width: 45px;\n  height: auto;\n}\n\n.mobdata1 {\n  text-align: right;\n  position: relative;\n  float: left;\n  vertical-align: text-top;\n  max-width: 453px;\n  height: auto;\n}\n\n.miledata {\n  font-size: 11px;\n  position: relative;\n  padding-left: 2px;\n  width: 50%;\n}\n\n.app-image-gallery {\n  width: 500px;\n  height: 500px;\n}\n\n.app-image-gallery-travel {\n  width: 453px;\n  height: 453px;\n  margin-left: 0px;\n  object-fit: fill;\n}\n\n.app-image-gallery-place {\n  width: 453x;\n  height: 453px;\n}\n\n.app-image-gallery-media {\n  width: 453px;\n  height: 453px;\n}\n\n.app-image-gallery_horz {\n  width: 453px;\n  height: 453px;\n}\n\n.app-image-gallery-map {\n  width: auto;\n  height: 453px;\n  margin-left: 10px;\n  max-width: 900px;\n}\n\n.app-image-gallery-explurge {\n  width: auto;\n  height: 453px;\n}\n\n.image_total_horz {\n  width: auto;\n  height: 318px;\n  margin-left: 10px;\n  max-width: 900px;\n}\n\n.image_total {\n  min-width: 453px;\n  max-height: 800px !;\n  object-fit: fill;\n}\n\n.image_slide {\n  width: 453px;\n  height: 453px;\n  object-fit: fill;\n}\n\n.image_slide_map1 {\n  min-width: auto;\n  max-height: 318px;\n  float: left;\n}\n\n.image_slide_map_will_travel {\n  width: 350px;\n  height: 350px;\n  margin-left: 20px;\n  object-fit: fill;\n}\n\n.image_slide_map_will_travel1 {\n  width: 350px;\n  height: 350px;\n  margin-left: 20px;\n  margin-top: 110px;\n}\n\n.image_slide_map2 {\n  min-width: 318px;\n  max-height: 318px;\n  object-fit: fill;\n}\n\n.image_slide_map_explurge1 {\n  width: 453px;\n  height: 453px;\n  align-items: left;\n  cursor: none;\n}\n\n.image_slide_map_explurge2 {\n  width: 100%;\n  height: auto;\n  max-width: 600px;\n  max-height: 318px;\n  object-fit: fill;\n}\n\n.image-gallery-slide .image-gallery-image-new {\n  width: 453px !important;\n  height: 453px !important;\n  margin-left: 40px;\n}\n\n.image-gallery-image-travel {\n  width: 453px;\n  height: 453px;\n  object-fit: fill;\n  margin-left: 0px;\n}\n\n.image-gallery-slides.image-gallery-image-travel_1 {\n  width: 550px ! important;\n  height: 550px ! important;\n  display: inline-block;\n}\n\n.image-gallery-image-media {\n  width: 100%;\n  height: 453px;\n  min-width: 453px;\n  max-height: 453px;\n  object-fit: fill;\n}\n\n.image-gallery-image-horz {\n  width: 100%;\n  height: 318px;\n  min-width: 318px;\n  max-height: 453px;\n  object-fit: fill;\n}\n\n.video-wrapper {\n  width: 100%;\n  height: auto;\n}\n\n.video-wrapper-travel {\n  width: 100%;\n  height: auto;\n  margin-top: 0px;\n  padding-top: 0px;\n}\n\n.image-gallery-slides {\n  align-items: left !;\n  text-align: left;\n}\n\n.image-gallery-bullets .image-gallery-bullets-container {\n  padding: 0;\n  text-align: left !;\n}\n\n.slide-image-data {\n  padding: 0;\n  vertical-align: top;\n  margin-left: 0px;\n  max-width: 100%;\n  height: auto;\n}\n\n.image-gallery-content {\n  margin-left: 0px;\n}\n\n.image-image-travel {\n  width: 350px;\n  height: 175px;\n\n}\n\n.image-image-media {\n  width: 350px;\n  height: 350px;\n  max-width: 100%;\n  max-height: 453px;\n  min-width: 350px;\n  object-fit: cover;\n  object-position: bottom;\n}\n\n.image-image-media-place {\n  width: 200px;\n  height: 200px;\n  float: left;\n  position: relative;\n}\n\n.image-place-thumb {\n  position: relative;\n  float: left;\n}\n\n.image-image-travel-place {\n  width: 350px;\n  height: 175px;\n  vertical-align: top;\n}\n\n.will-travel-place {\n  position: relative;\n  float: left;\n\n}\n\n.will-travel-map {\n  margin-top: 0;\n  vertical-align: top;\n  position: relative;\n  float: left;\n  width: 318px;\n  height: 100px;\n  margin-left: 20px;\n\n}\n\n.will-travel-map2 {\n  margin-top: 0;\n  margin-left: 20px;\n  width: 100px;\n  height: 100px;\n}\n\n.explurge-travel-map {\n  margin-top: 0;\n  width: 200px;\n  height: 200px;\n  position: relative;\n  float: left;\n}\n\n.explurge-travel-map2 {\n  margin-top: 0;\n  margin-left: -30px;\n  vertical-align: top;\n  width: 453px;\n  height: 200px;\n}\n\n.explurge-travel-map-map {\n  margin-top: 0;\n  margin-left: 0px;\n  max-width: 100%;\n  max-height: 100px;\n  width: 453px;\n  object-fit: cover;\n  height: auto;\n}\n\n.mob_line_bottom {\n  border: 1.1px solid #E6E6E6;\n  padding-top: 0px;\n  padding-left: 0px;\n  margin-left: 0px;\n  margin: 5px 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.mob_line_top {\n  margin-top: 10px;\n  margin-right: 0px;\n}\n\n.videodata {\n  width: 500px;\n  height: 500px;\n}\n\n.cardbody {\n  width: auto;\n}\n\n.customedata {\n  height: auto;\n  width: 40%;\n  position: relative;\n  float: left;\n  background-color: #F2F3F4;\n}\n\n.image-map {\n  margin-left: -100px;\n}\n\n.map-image {\n  margin-left: 0px;\n  object-fit: cover;\n}\n\n.travel-data {\n  margin-left: 10px;\n  margin-right: 0px;\n  width: 500px;\n  align-items: center;\n  background-color: dodgerblue;\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.profile-post-line {\n  margin-left: 0px;\n  position: relative;\n  float: left;\n  margin-top: 10px;\n  justify-content: center;\n}\n\n.profile-post-line-right {\n  margin-left: 0px;\n  margin-top: 10px;\n  width: 70%;\n\n}\n\n.profile-image-post-line {\n  margin-left: 0px;\n}\n\n.play_but_img {\n  z-index: -1;\n  position: absolute;\n  top: 130px;\n  left: 160px;\n  align-items: center;\n  opacity: 0.6;\n}\n\n.video {\n  border: 5px solid red;\n  /*Your CSS here for styling*/\n}\n\n.app-text {\n  margin-left: 10px;\n}\n/*\n.image_profile_post {\n  width: 385px;\n  height: 385px;\n}\n*/\n\n.textcolor {\n  height: 100px;\n  width: 60%;\n  position: relative;\n  float: left;\n  background-color: #646464;\n  word-wrap: break-word;\n  word-break: break-word;\n  text-align: left;\n}\n\n.textcolor-noimage {\n  position: relative;\n  background-color: #F2F3F4;\n  width: 100%;\n  height: auto;\n  margin-left: 0px;\n  padding-left: 0px;\n  word-wrap: break-word;\n  text-align: left;\n  font-size: 12px;\n}\n\n/*********************************/\n.slider-with-video img,\n.slider-img img {\n  max-width: 100%;\n}\n\n.post-details {\n  margin-top: 15px;\n  margin-left: 0px;\n}\n\n.post-details-inner {\n  position: relative;\n  float: left;\n  width: 85%;\n  padding-top: 14px;\n  padding-left: 15px;\n  left: 5%;\n  height: auto;\n  word-wrap: break-word;\n}\n\n.whitescale {\n  filter: invert(1);\n}\n\n.date-color {\n  font-family: 'Open Sans', sans-serif;\n  color: #646464;\n  font-size: 0.875em;\n}\n\n#more {\n  display: none;\n}\n\n.traveltext {\n  margin-top: 10px;\n}\n\n.creater_thumbpic {\n  background-color: #bbb;\n  border-radius: 50%;\n  display: inline-block;\n  position: relative;\n\n}\n\n.frame-fix {\n  max-width: 500px;\n  max-height: 500px;\n  position: relative;\n  margin: auto;\n}\n\n.image-kudo {\n  position: relative;\n  float: left;\n  margin-top: 0px;\n}\n\n/*************************************/\n\n.card_main {\n  position: relative;\n  padding-top: 0px;\n  margin-top: 0px;\n  ;\n  /**************/\n  border-radius: 25px;\n  border: 2px solid #cccccc;\n  padding: 20px;\n  width: 500px;\n  max-width: 500px;\n  height: 900px;\n  max-height: 100%;\n\n  align-content: center;\n  padding-left: 0px;\n  margin-left: 10px;\n  font-size: 12px;\n  /*****************/\n\n}\n\n/*.card {  \n    position:relative;\n    padding-top: 0px;\n    margin-top:0px;;\n    border: 1px solid #cccccc;\n    padding: 20px; \n    max-width:600px;\n    height: 900px;\n    max-height:900px;\n    align-content: center;\n    padding-left:0px;\n    margin-left:10px;\n    font-size:10px;       \n    }*/\n\n/*\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\nbody {\n  background-color: #003066;\n} */\n.container-frame {\n  padding-top: 0px;\n  margin-top: 5px;\n}\n\n.card-inner {\n  max-width: 50rem;\n}\n\n/***********************************/\n.footer-left {\n  position: fixed;\n  float: left;\n  width: 100%;\n}\n\n.footer-left-inner1 {\n  width: 40%;\n  margin-top: 0px;\n  text-align: center;\n  position: relative;\n  float: left;\n}\n\n.footer-left-inner2 {\n  width: 30%;\n  margin-top: 0px;\n  text-align: center;\n  position: relative;\n  float: left;\n\n}\n\n.footer-left-inner3 {\n  width: 30%;\n  margin-top: 0px;\n  text-align: center;\n  position: relative;\n  float: left;\n}\n\n.footer-left-inner4 {\n  width: 40%;\n  margin-top: 0px;\n  text-align: left;\n  position: relative;\n  float: left;\n}\n.footer-left-inner5 {\n  width: 60%;\n  margin-top: 0px;\n  text-align: right;\n  position: relative;\n  float: right;\n}\n\n@media screen and (min-width: 768px) {\n  .footer-left-inner4 {\n    width: 45%;\n    margin-top: 0px;\n    text-align: left;\n    position: relative;\n    float: left;\n    padding: 0 5px;\n  }\n  .footer-left-inner5 {\n    width: 55%;\n    margin-top: 0px;\n    text-align: right;\n    position: relative;\n    float: right;\n    padding: 0 5px;\n  }\n\n  .kudo-count-container {\n    margin-left: 5px;\n  }\n}\n\n.bucket-area {\n  background-color: #0195F7;\n  display: inline-block;\n}\n\n.bucket-inner {\n\n  float: left;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: normal;\n  font-weight: bold;\n  align-items: right;\n}\n\n.bucket-inner1 {\n  color: #ffffff;\n  font-size: 12px;\n  width: 20%;\n  font-weight: normal;\n  font-weight: bold;\n\n}\n\n.bucket-inner2 {\n  color: #ffffff;\n  font-size: 12px;\n  width: 20%;\n  font-weight: normal;\n  font-weight: bold;\n\n}\n\n.bucket-inner3 {\n  color: #ffffff;\n  font-size: 12px;\n  width: 20%;\n  font-weight: normal;\n  font-weight: bold;\n\n}\n\n.bucket-inner4 {\n  width: 20%;\n}\n\n.bucket-inner5 {\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: normal;\n  font-weight: bold;\n  align-items: right;\n  margin-top: 0px;\n  padding-top: 5px;\n  z-index: 2;\n}\n\n.btn-text {\n  border-radius: 15px;\n  background-color: white;\n  color: blue;\n  align-items: right;\n  border-color: #ffffff;\n  padding-left: 5px;\n  margin-left: 40px;\n  margin-top: 7px;\n  height: 30px;\n}\n\n.btn-text-down {\n  background-color: #0195F7;\n  height: 35px;\n  margin-left: 0px;\n  margin-top: 0px;\n  padding-top: 0px;\n  width: 100%;\n}\n\n.btn-text-travel {\n  position: absolute;\n  background-color: #0195F7;\n  height: 40px;\n  margin-top: 0px;\n  position: relative;\n  width: 100%;\n}\n\n.btn-text-travel_no {\n  background-color: #0195F7 ! important;\n  height: 40px;\n  margin-top: 0px;\n  position: relative;\n  width: 100%;\n}\n\n.btn-text-spread {\n  font-size: 10px;\n  ;\n  background-color: #0195F7;\n  height: 35px;\n  margin-left: 0px;\n  margin-top: 0px;\n  padding-top: 0px;\n  width: 90%\n}\n\n.btntxt {\n  width: 30%;\n  border-radius: 15px;\n  background-color: white;\n  color: #2196F3;\n  align-items: right;\n  border-color: #ffffff;\n  padding-left: 5px;\n  margin-left: 15px;\n  margin-top: 8px;\n  height: 20px;\n  margin-right: 5px;\n  font-size: 10px !important;\n}\n\n.btn-left {\n  width: 10%;\n  margin-top: 3px;\n  margin: left 0px;\n  float: left;\n  color: #ffffff;\n}\n\n.travel-place-map {\n  width: 318px;\n  height: 100px;\n\n}\n\n.travel-place-image {\n  width: 135px;\n  height: 100px;\n}\n\n.expl-place-image {\n  max-height: 200px;\n  align-items: stretch;\n  object-fit: cover;\n  padding: 0px;\n}\n\n.expl-place-map {\n  margin-left: 0px;\n  margin-top: 0px;\n  padding: 0px;\n  padding-left: 0px;\n  width: 60%;\n  height: 100%;\n  object-fit: cover;\n  padding: 0px;\n\n}\n\n.footer-images {\n  width: 100%;\n  max-width: 100%;\n  max-height: 200px;\n  padding-top: 0px;\n  margin-top: 0px;\n}\n\n.image-2 {\n  position: fixed;\n  max-height: 200px;\n  max-width: 453px;\n\n}\n\n.img-fluid {\n  height: 200px !important;\n  object-fit: cover;\n  padding: 0px;\n}\n\n.card_add {\n  width: 100%;\n  background-color: #FDFFFD;\n}\n\n.phone {\n  padding-top: 0px;\n  display: flex;\n  align-items: center;\n  width: 478px;\n  max-height: 100%;\n  height: 900px;\n  background: #cccccc;\n  border-radius: 30px;\n  border-color: red;\n  padding: 10px;\n  border: 2px;\n}\n\n* .container img {\n  display: inline-block;\n  height: 100px;\n  z-index: 0;\n\n}\n\nimg.right_image {\n  width: 70%;\n  height: 100px;\n  max-width: 318px;\n  object-fit: cover;\n  z-index: -1;\n}\n\nimg.left_image {\n  float: left;\n  width: 30%;\n  max-width: 318px;\n  height: 100px;\n}\n\nimg.leftimage {\n  float: left;\n  width: 30%;\n}\n\nimg.leftimage_2 {\n  float: left;\n  width: 70%;\n  margin-top: 0px;\n\n}\n\nimg.rightimage_2 {\n  float: left;\n  width: 30%;\n  margin-top: 0px;\n}\n\nimg.rightimage {\n  float: left;\n  width: 70%;\n  padding-right: 0px;\n}\n\n.left_image_spread {\n  float: left;\n  width: 70%;\n}\n\n.right_image_spread {\n  float: left;\n  width: 30%;\n}\n\n.col-md-6 {\n  float: left;\n  object-fit: contain;\n  ;\n}\n\n.container-single {\n  width: 100%;\n}\n\n.side-pro-kudo {\n  position: relative;\n  float: left;\n}\n\n.upper-image-map {\n  position: relative;\n  float: left;\n}\n\n.container {\n  margin-top: 0px;\n  padding-left: 0px;\n  margin-left: 0px;\n  width: 100%;\n  height: auto;\n  z-index: 1;\n  padding-right: 0px;\n}\n\n.img-left {\n  position: relative;\n  float: left;\n\n}\n\n.img-circle {\n  border-radius: 50%;\n  width: 20px;\n  margin-top: 0px;\n}\n\n.data-resp {\n  position: absolute;\n  display: inline-block;\n  width: 318px;\n  max-width: 100%;\n  padding-top: 0px;\n  padding-left: 0px;\n  word-break: break-all;\n  /* optional */\n}\n\n.square {\n\n  border-color: #cccccc;\n  border-width: 4px;\n  width: 480px;\n  height: 900px;\n  padding: 5px;\n\n}\n\n.square h1 {\n  color: #fff;\n}\n\n.image-gallery-center {\n  z-index: 2;\n}\n\n.min_profile {\n  width: 80%;\n}\n\n.img_data {\n  width: 15%;\n  position: relative;\n  float: left;\n  padding: 10px 0; \n}\n\n.block-box {\n  background-color: #FDFFFD;\n  font-family: 'Open Sans';\n  font-size: 10px;\n  position: relative;\n  /*border: 2px solid #cccccc;*/\n  margin: 0px;\n  padding-top: 0px;\n  margin-top: 0px;\n  height: auto;\n  max-height: 900px;\n  display: flex;\n  align-content: center;\n  border-radius: 20px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  margin-top: 4px;\n  justify-content: center;\n}\n\n.block-pro {\n  width: 100%;\n  padding: 0px;\n  margin: 0px;\n\n}\n\n.box-5 {\n  width: 100%;\n  height: auto;\n  padding: 0px;\n  margin: 0px;\n  margin-top: 0px;\n  font-size: 12px;\n}\n\n.box-1 {\n  display: block;\n  position: relative;\n  /* border:.4px solid #cccccc; */\n  width: 100%;\n  height: auto;\n  padding: 0px;\n  padding-left: 0px;\n  margin: 0px;\n  z-index: 0px;\n  /* margin-top: -5px; */\n  margin-left: 0px;\n}\n\n.box-spraed-1 {\n  display: block;\n  position: relative;\n  border: .4px solid #cccccc;\n  width: 96%;\n  height: auto;\n  margin: 6px;\n  z-index: 0px;\n  margin-top: 5px;\n  margin-left: 5px;\n}\n\n.box-2 {\n  width: 100%;\n  height: 100px;\n  padding: 0px;\n  margin: 0px;\n  margin-top: 0px;\n}\n\n.box-4 {\n  width: 350px;\n  height: 350px;\n  padding: 0px;\n  margin: 0px;\n  border: 1px solid #cccc;\n\n}\n\n.box-3 {\n  border-color: #FDFFFD;\n  width: 100%;\n  height: auto;\n  padding: 0px;\n  margin: 0px;\n  margin-top: 0px;\n}\n\n.limage {\n  float: left;\n  width: 70%;\n  max-width: 318px;\n}\n\n.rimage {\n  width: 30%;\n  max-width: 115px;\n}\n\n.card-body {\n  padding: 0px;\n}\n\n.data-match {\n  width: 78%;\n  padding-top: 20px;\n  /* padding-left: 1em; */\n  font-size: 13px;\n  /* text-align: justify; */\n  overflow: hidden;\n  display: inline-block;\n  /* margin-left: -15px; */\n}\n\n.imgclass {\n  position: relative;\n  float: left;\n  padding-top: 0px;\n  margin-top: 3px;\n  margin-left: 1px;\n}\n\n.linkclass {\n  object-fit: cover;\n}\n\n.imgclassrun {\n  margin-top: -5px;\n  padding-top: -5px;\n  padding-left: 4px;\n}\n\n.kudotext {\n  position: relative;\n  float: left;\n  /* padding-left:4px;\n  padding-top:0px;\n  margin-top:-2px; */\n  color: #646464;\n\n}\n\n.say_spread_text {\n  text-align: right;\n  margin-top: 0px;\n  padding-top: 0px;\n}\n\n.dot {\n  height: 4px;\n  width: 4px;\n  padding-top: 0px;\n  margin-top: 11px;\n  margin-left: 7px;\n  background-color: #646464;\n  border-radius: 50%;\n  float: left;\n}\n\n.dot-say {\n  position: relative;\n  float: left;\n  margin-left: 10px;\n  text-align: right;\n  color: #646464;\n}\n\n.dot-spread {\n  position: relative;\n  float: left;\n  margin-right: 0px;\n  text-align: left;\n  color: #646464;\n}\n\n.kudo-alldata {\n  float: left;\n  width: 55%;\n  padding-left: 0px;\n  padding-top: 0px;\n}\n\n.data_left {\n  position: relative;\n  float: left;\n  /* padding-left: 2px; */\n}\n\n.play_icon {\n  background: none;\n  width: 100px;\n  height: 50px;\n  border: solid 5px #fff;\n  border-radius: 100%;\n  position: absolute;\n  text-indent: -9999px;\n  box-shadow: 1px 1px 3px #999999;\n  z-index: 1;\n  padding-left: 0px;\n  padding-top: 0px;\n  margin-left: 10em;\n  margin-top: 10em;\n}\n\n.justify-content-center {\n  z-index: 0 ! important;\n  left: 0px;\n  margin-left: 0px;\n}\n\n.image-gallery-bullets {\n  background-color: transparent;\n  /* outline: 2px dashed; */\n  /* transform: rotate(180deg); */\n\n\n}\n\n.travel_data {\n  padding-top: 20px;\n  padding-left: 10px;\n  font-size: 14px;\n  color: #ffffff;\n  float: left;\n  font-weight: bold;\n\n}\n\n.traveltxt {\n  font-size: 12px;\n  color: #ffffff;\n  float: left;\n  text-align: center;\n  padding-top: 0px;\n  margin-top: -2px;\n  float: left;\n  padding-left: 20px;\n\n}\n\n.traveltxt_days {\n  font-size: 12px;\n  color: #ffffff;\n  float: left;\n  text-align: center;\n  padding-top: 0px;\n  margin-top: -36px;\n  padding-left: 20px;\n  margin-left: 0px;\n\n}\n\n.traveltxt_days-only-u {\n  font-size: 12px;\n  color: #ffffff;\n  float: left;\n  text-align: center;\n  padding-top: 0px;\n  margin-top: -36px;\n  padding-left: 20px;\n  margin-left: 0px;\n}\n\n.traveltxt_days-only-d {\n  font-size: 12px;\n  color: #ffffff;\n  float: left;\n  text-align: center;\n  padding-top: 0px;\n  margin-top: -2px;\n  padding-left: 20px;\n  margin-left: 0px;\n}\n\n.traveltxt_days_up {\n  font-size: 12px;\n  color: #ffffff;\n  float: left;\n  text-align: center;\n  padding-top: 0px;\n  margin-top: -35px;\n  padding-left: 20px;\n  margin-left: 0px;\n}\n\n.traveltxt_days_down {\n  font-size: 12px;\n  color: #ffffff;\n  float: left;\n  text-align: center;\n  padding-top: 0px;\n  margin-top: -2px;\n  padding-left: 20px;\n  margin-left: 0px;\n}\n\n.traveltxt_days_down {\n  font-size: 12px;\n  color: #ffffff;\n  float: left;\n  text-align: center;\n  padding-top: 0px;\n  padding-left: 20px;\n  margin-left: 0px;\n}\n\n.pic-travel {\n  font-size: 8px;\n  color: #ffffff;\n  padding-top: 1px;\n  padding-left: 0px;\n  margin-top: 1px;\n  margin-left: 3px;\n  float: left;\n}\n\n.pic-travel_upper {\n  font-size: 8px;\n  color: #ffffff;\n  padding-top: 6px;\n  padding-left: 0px;\n  margin-top: 0px;\n  margin-left: 0px;\n  float: left;\n}\n\n\n\n.travel_time {\n  font-size: 20px;\n  color: #ffffff;\n  font-weight: bold;\n\n}\n\n.notouch {\n  cursor: pointer;\n  pointer-events: auto;\n  margin-right: 0px;\n  margin-left: 0px;\n  align-items: center;\n\n}\n\n.cover_image_profile {\n  padding-top: 0px;\n  margin-left: 0px;\n  align-self: left;\n  align-content: left;\n  background-color: #cccccc;\n  height: auto;\n  max-width: 100%;\n}\n\n.text-text {\n  text-align: justify;\n  text-justify: inter-word;\n}\n\n.btnmark {\n  background-color: white;\n  padding-top: 0px;\n  margin-top: -10px;\n}\n\n.blanktab {\n  width: 10%;\n}\n\n.sayonly {\n  width: 45%;\n  padding-left: 0px;\n\n}\n\n.sayonly1 {\n  width: 50%;\n  text-align: right;\n  margin-left: 40px;\n}\n\n.sayonly2 {\n  width: 50%;\n  text-align: right;\n  margin-left: 40px;\n\n\n}\n\n.btn-bucket-center {\n  font-size: 11px;\n  color: #ffffff;\n  float: left;\n  margin-top: 9px;\n  padding-left: 5px;\n\n}\n\n.strokclass {\n  stroke: #f0ebeb;\n  stroke-width: 2;\n}\n\n.side-upper {\n  margin-top: -10px;\n  /*padding-bottom: 3px; */\n}\n\n.kudo-mark {\n  margin-top: 5px;\n  margin-right: 5px;\n}\n\n.test_data {\n  margin-top: 0px;\n  margin-right: 0px;\n}\n\n.truncate {\n  position: relative;\n  float: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  /* number of lines to show */\n  line-clamp: 5;\n  -webkit-box-orient: vertical;\n}\n\n.subtruncate {\n  position: relative;\n  float: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  /* number of lines to show */\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.button {\n  font-family: 'open-sens';\n  font-size: .875em;\n}\n\n.textcolor_noimage {\n  height: auto;\n  background-color: #F2F3F4;\n}\n\n.capstext {\n  position: relative;\n  float: left;\n}\n\n.ml {\n  margin-left: 2px;\n}\n\n.domaindata {\n  padding-left: 2px;\n  color: #646464;\n  text-decoration: none;\n}\n\n.textml {\n  position: relative;\n  float: left;\n}\n\n.image_profile_post1 {\n  margin-top: 4px;\n  height: 45px;\n  margin-left: 10px;\n  margin-bottom: -5px;\n  stroke-width: 1.5px;\n  stroke: #726d6d;\n}\n\n.kudoImg {\n  height: 25px;\n}\n\n.kudo {\n  margin-left: 350px;\n}\n\n.says {\n  margin-left: 350px;\n}\n\n.spread {\n  margin-left: 350px;\n}\n\n.kudosView {\n  /* margin-top: -18px; */\n}\n\n.milesImg {\n  height: 17px;\n  /* filter: saturate(0.5); */\n  margin-bottom: 6px;\n}\n\n.milesText {\n  color: #2d58a8;\n}\n\n.postString {\n  margin-left: 3px;\n}\n\n.nameMiles {\n  text-decoration: dashed;\n}\n\n.mediaImg {\n  width: 398px;\n  height: 238.8px;\n}\n\n.postCard {\n  width: 425px;\n  max-height: 750px;\n  \n}\n\n.postCard2 {\n  width: 425px;\n  max-height: inherit;\n}\n\n.postCard3 {\n  width: 425px;\n  max-height: inherit;\n}\n\n.postCard3 .box-1 .BoxPostWoner {\n  /* border: .4px solid #cccccc; */\n}\n\n.p101010{\n  padding: 0 10px 10px 10px;\n}\n\n.Map_Place_Thumb_Photo {\n  object-fit: cover;\n  width: 136px;\n  height: 148px;\n}\n\n.Map_Place_Photo_Url {\n  object-fit: cover;\n  width: 290px;\n  height: 148px;\n  margin-left: -1px;\n}\n\n\n.postText {\n  font-size: small;\n  word-wrap: break-word;\n}\n\n.previewTitle,\n.previewDesc,\n.previewLink {\n  font-size: small;\n  word-wrap: break-word;\n}\n\n.previewImg {\n  object-fit: cover;\n  /* height: 425px;\n  width: 360px; */\n  width: 100%;\n  height: auto;\n}\n\n.badg-verified {\n  height: 18px;\n  margin-right: 2px;\n}\n\n.loader {\n  /* margin-left: 200px; */\n}\n\n.mainLoader {\n  border-color: rgb(37 89 177) rgb(37 89 177) transparent !important;\n}\n\n.kudosView {\n  font-size: small;\n  padding: 10px 0px;\n}\n\n.videoView {\n  object-fit: cover;\n  /* height: 425px;\n  width: 425px; */\n  cursor: pointer;\n}\n\n.videoExplrView {\n  object-fit: cover;\n  /* height: 425px;\n  width: 100%; */\n  cursor: pointer;\n  /* padding-bottom: 15px; */\n}\n.videoExplrView225 {\n  object-fit: cover;\n  /* height: 225px;\n  width: 100%; */\n  cursor: pointer;\n  /* padding-bottom: 15px; */\n}\n\n.imageView {\n\n  height: inherit;\n  width: inherit;\n\n}\n\n.imageViewBox {\n  object-fit: cover;\n  /* height: 425px;\n  width: 100%; */\n}\n.imageViewBox2 {\n  object-fit: cover;\n  /* height: 425px;\n  width: 100%; */\n}\n.imageViewBox3Single {\n  object-fit: cover;\n  /* max-height: fit-content; */\n  /* width: 100%;\n  height: 425px; */\n}\n\n.imageViewBox225 {\n  object-fit: cover;\n  /* height: 225px;\n  width: 100%; */\n}\n\n.profilePic {\n  object-fit: cover;\n  /* height: 425px;\n  width: 100%; */\n}\n\n.coverPic {\n  object-fit: cover;\n  /* height: 250px;\n  width: 425px; */\n  /* width: 100%; */\n  /* height: auto; */\n  /* height: 425px; */ \n}\n\n.imageViewBoxFullScreen{\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;  \n}\n\n.imageViewBoxFullScreen .imageViewBox {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;  \n}\n\n.imageViewBoxFullScreen .imageViewBox .imageView {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;    \n}\n\n\n\n\n.kudoVal {\n  /* margin-left: -25px; */\n}\n\n.saysVal1 {\n  margin-left: 15px;\n}\n\n.preadVal1 {\n  margin-right: -38px;\n}\n\n.kudosProfile3,\n.kudosProfile2,\n.kudosProfile {\n  width: 20px;\n  border-radius: 50%;\n}\n@media screen and (max-width: 425px) {\n  .kudosProfile2 {\n    width: 18px;\n  }  \n  .kudosProfile3 {\n    width: 13px;\n  }\n}\n\n\n.kudosProfile:hover {\n  cursor: pointer;\n}\n\n/* .cover {\n  object-fit: cover;\n  width: 50px;\n  height: 100px;\n} */\n\n.paging-item {\n  opacity: 1.5 !important;\n  fill: #ffffff !important;\n  width: 12px;\n}\n\n.active {\n  fill: #32a8e4 !important;\n}\n\n.slider-control-centerright,\n.slider-control-centerleft {\n  display: none !important;\n}\n\n.slider-control-bottomcenter {\n  margin: 0px !important;\n}\n\n.paging-dot {\n  height: 7px;\n  width: 7px;\n  border: 1px solid lightslategray;\n  border-radius: 100%;\n}\n\n.slider-container .slider-control-bottomcenter {\n  margin-bottom: 50px !important;\n}\n\n.explurgen-with-media .imageView {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n}\n\n.playIcon {\n  height: 50px;\n  position: absolute;\n  margin-left: 12rem;\n  margin-top: 12rem;\n  cursor: pointer !important;\n  opacity: 80%;\n  background: #B73A3A3A;\n  border-radius: 50px;\n}\n\n.fade:not(.show) {\n  opacity: 1;\n}\n\n.video-react {\n  padding-top: 0px !important;\n}\n\n/* .playIcon {\n  display: none;\n}\n    \n.videoView:hover + .playIcon {\n  display: block;\n} */\n\n\n.scroll-div {\n  height: auto;\n  /* margin-top: 81px; */\n  position: sticky;\n}\n\n.sticky-div {\n  /* background-color: green; */\n  /* position: fixed;\n  top: 0px; */\n  /* padding: 10px 0px; */\n\n  top: 0px;\n  display: block;\n  /* left: 0px; */\n  position: fixed;\n  overflow: hidden;\n  z-index: 1;\n  width: 100%;\n  max-width: 428px;\n}\n\n.top-div {\n  padding: 20px 0px;\n  background-color: white;\n}\n\n.top-section {\n  background: #FDFFFD;\n  position: fixed;\n  position: fixed;\n  z-index: 999;\n  padding-bottom: -28px;\n  height: 60px;\n}\n\n.header-data {\n  display: flex;\n  margin-top: 8px;\n}\n\n.logoImg {\n  height: 40.83px;\n  width: 78.38px;\n}\n\n.openAppBtn {\n  border-radius: 25px;\n  background-color: #D9D9D9;\n}\n.openAppBtn:hover{\n  background-color: #D9D9D9;\n}\n\n.fade {\n  background-color: #05040482;\n}\n\n.btn-primary {\n  background-color: #0195F7;\n}\n\n.notNow {\n  height: 14px;\n  width: 55px;\n  text-decoration: none;\n  cursor: pointer;\n  color: #0195F7;\n  font-family: 'Roboto';\n  font-size: 14px;\n}\n\n.flex-parent {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.Place_Photo_Box {\n  height: 136px;\n  width: 30%;\n}\n\n.Place_Photo_Box img {\n  width: 100%;\n  height: 100%;\n}\n\n.Map_Photo_Box {\n  width: 70%;\n  height: 136px;\n}\n\n.Map_Photo_Box img {\n  width: 100%;\n  height: 100%;\n}\n\n.main {\n  width: 28vw;\n  margin-left: 32%;\n  background: #FDFFFD;\n  position: fixed;\n  position: fixed;\n  z-index: 999;\n  padding-bottom: -28px;\n  height: 60px;\n}\n\n/* .image_profile_post {\n  width: 415px;\n  height: 385px;\n  padding-top: 0px;\n  margin-left: 0px;\n} */\n\n.strokclassPost {\n  stroke: #f0ebeb;\n  stroke-width: 0.5;\n}\n\n.Level_Icon {\n  height: 30px;\n  position: absolute;\n  /* top: 60px; */\n  right: 0px;\n  z-index: 999;\n  margin-top: -14px;\n}\n\n.read-or-hide {\n  cursor: pointer;\n}\n\n.AddbucketListBtn {\n  border-radius: 25px;\n  --bs-btn-padding-y: -0.75rem;\n  --bs-btn-padding-x: 0.5;\n  --bs-btn-font-size: 0.7rem;\n  margin-top: 8px;\n  margin-right: 8px;\n  width: 100px;\n  color: #0195F7;\n}\n\n.modalUserProfile .image_profile {\n  width: 70px;\n  height: 69.97px;\n}\n\n.modalUserProfileCenter .image_profile {\n  width: 70px;\n  height: 69.97px;\n}\n\n.getTheApp {\n  border-radius: 30px;\n  width: 100%;\n  background: #0195F7;\n  color: #FFFFFF;\n  font-weight: bold;\n  margin-bottom: 15px;\n  font-size: 14px;\n  line-height: 20px;\n  height: 40px;\n}\n\n.getTheApp:hover {\n  background: #0195F7;\n  color: #FFFFFF;\n}\n\n.getTheAppCenetr {\n  top: 783px;\n  left: 20px;\n  border-radius: 30px;\n  width: 230px;\n  height: 40px;\n  background: #0195F7;\n  color: #FFFFFF;\n  margin-bottom: 15px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.getTheAppCenetr:hover {\n  background: #0195F7;\n  color: #FFFFFF;\n}\n\n.profile-pic-post-row{\n  background: darkgray;\n}\n.m10px00 {\n  margin: 10px 0px 0px;\n}\n.m0 {\n  margin: 0px;\n}\n.m5_0 {\n  margin: 5px 0px;\n}\n.p0 {\n  padding: 0px;\n}\n.p1 {\n  padding: 1px;\n}\n.p2 {\n  padding: 2px;\n}\n.p3 {\n  padding: 3px;\n}\n.p4 {\n  padding: 4px;\n}\n.p5 {\n  padding: 5px;\n}\n\n.plr0 {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.w33p {\n  width: 33%;\n}\n.w67p {\n  width: 67%;\n}\n\n.img_container1 {\n  width: 33%; /* adjust to container size as needed */\n  /* height: 500px; adjust to container size as needed */\n  /* height: 425px; */\n  padding: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.img_container2 {\n  width: 67%; /* adjust to container size as needed */\n  /* height: 500px; adjust to container size as needed */\n  /* height: 425px; */\n  padding: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.img_container1 img, .img_container2 img, .imageViewBox img {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  /* object-fit: contain; */\n  /* object-fit: cover; */\n  object-fit: fill;\n  vertical-align: middle;\n}\n\n.vjs-poster img {\n  object-fit: fill !important;\n}\n\n.imageViewBox2 img, .imageViewBox3Single img, .imageViewBox225 img {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  vertical-align: middle;\n  object-fit: fill;\n}\n\n.kudo-count-container {\n  justify-content: center;\n  display: flex;\n  float: left;\n  /* margin-left: 25px; */\n}\n.kudo-user-names {\n  float: left;\n}\n.kudo-user-names img {\n  margin-left: 1px;\n}\n.kudo-counts {\n  margin-left: 5px;\n  float: left;\n}\n\n.fll {\n  float: left;\n}\n.flr {\n  float: right;\n}\n\n\n.videoViewCount {\n  position: absolute;\n  background-color: black;\n  box-sizing: border-box;\n  font-size: 14px;\n  color: #ffF;\n  z-index: 1;\n  padding: 0px 3px 0px 0px;\n  border-bottom-right-radius: 20%;\n}\n\n.videoViewCount_Icon {\n  height: 10px;\n  margin: 0px 2px 2px;\n}\n\n.seeTheFullProfileInAppModalDialog {\n  /* margin-top: 573px; */\n  width: 100%;\n  /* margin-left: 0px; */\n  position: fixed;\n  /* top: auto;\n  right: auto;\n  left: auto; */\n  bottom: -78.5px;\n  /* padding: 0px 1px; */\n}\n\n.seeTheFullProfileInAppModalDialog.midSeeMorePopup {\n    max-width: 330px;\n}\n\n.dontMissModalDialog {\n  /* margin-top: 372px;\n  width: 335px;\n  margin-left: 5px; */\n  position: fixed;\n  /* top: auto;\n  right: auto;\n  left: 5%; */\n  width: 80%;\n}\n\n/* On screens that are 600px wide or less, the background color is olive */\n@media screen and (max-width: 600px) and (max-width: 767px) {\n  /* body {\n    background-color: rgb(236, 236, 232);\n  } */\n\n  .main {\n    width: 100vw;\n    margin-left: -12px;\n    background: #FDFFFD;\n    position: fixed;\n    position: fixed;\n    z-index: 999;\n    padding-bottom: -28px;\n    height: 55px;\n  }\n\n  .flex {\n    display: flex;\n    gap: 16px;\n  }\n\n  .btn-primary {\n    background-color: #0195F7;\n  }\n\n\n  .coverPic {\n    object-fit: cover;\n    /* height: 220px;\n    width: 385px; */\n    width: 100%;\n    /* height: auto; */\n  }\n\n  .videoView {\n    object-fit: cover;\n    height: 425px;\n    width: 425px;\n    cursor: pointer;\n  }\n\n  .previewImg {\n    object-fit: cover;\n    /* height: 425px;\n    width: 360px; */\n    width: 100%;\n    height: auto;\n  }\n\n  .Map_Place_Thumb_Photo {\n    object-fit: cover;\n    width: 128px;\n    height: 120px;\n  }\n\n  .Map_Place_Photo_Url {\n    object-fit: cover;\n    width: 259px;\n    height: 120px;\n    margin-left: -24px;\n  }\n\n  .explurgen-with-media .imageView {\n    object-fit: cover;\n    height: 100%;\n    width: 100%;\n  }\n\n  .profilePic {\n    object-fit: cover;\n    height: 425px;\n    width: 383px;\n  }\n\n  .playIcon {\n    height: 50px;\n    position: absolute;\n    margin-left: 10rem;\n    margin-top: 13rem;\n    cursor: pointer !important;\n    opacity: 80%;\n  }\n\n  .footer-left-inner1 {\n    width: 35%;\n    margin-top: 0px;\n    text-align: center;\n    position: relative;\n    float: left;\n  }\n\n  .footer-left-inner2 {\n    width: 30%;\n    margin-top: 0px;\n    text-align: center;\n    position: relative;\n    float: left;\n  }\n\n  .footer-left-inner3 {\n    width: 35%;\n    margin-top: 0px;\n    text-align: center;\n    position: relative;\n    float: left;\n  }\n  .footer-left-inner4 {\n    width: 45%;\n    margin-top: 0px;\n    text-align: left;\n    position: relative;\n    float: left;\n    padding: 0 5px;\n  }\n  .footer-left-inner5 {\n    width: 55%;\n    margin-top: 0px;\n    text-align: right;\n    position: relative;\n    float: right;\n    padding: 0 5px;\n  }\n\n  /* .header {\n    position: fixed;\n    z-index: 999;\n    height: 61px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 34px;\n    background-color: #FDFFFD;\n  } */\n\n  .top-section {\n    background: #FDFFFD;\n    position: fixed;\n    position: fixed;\n    z-index: 999;\n    padding-bottom: -28px;\n    height: 60px;\n  }\n\n  .header-data {\n    display: flex;\n    margin-top: 8px;\n  }\n\n  .logoImg {\n    height: 40.83px;\n    width: 78.38px;\n  }\n\n  .openAppBtn {\n    border-radius: 25px;\n    background-color: #D9D9D9;\n  }\n\n  .openAppBtn:hover{\n    background-color: #D9D9D9;\n  }\n\n  .fade {\n    background-color: #05040482;\n  }\n\n  .seeTheFullProfileInAppModalDialog {\n    /* margin-top: 573px; */\n    width: 100%;\n    /* margin-left: 0px; */\n    position: fixed;\n    top: auto;\n    right: auto;\n    left: auto;\n    bottom: -57.5px;\n  }\n\n  .seeTheFullProfileInAppModalDialog.midSeeMorePopup {\n    max-width: 330px;\n  }\n\n  .modal-content {\n    background-color: #F9F9F9;\n  }\n\n  .getTheApp {\n    /* width: 374px;\n    height: 50px;\n    top: 783px;\n    left: 20px;\n    margin-left: -10px; */\n    border-radius: 30px;\n    width: 100%;\n    /* height: 50px; */\n    background: #0195F7;\n    color: #FFFFFF;\n  }\n\n  .modelTitle {\n    /* font-family: SF Pro Text; */\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 0px;\n    letter-spacing: -0.40799999237060547px;\n    text-align: center;\n    color: #000000;\n  }\n\n  .modelDesc {\n    /* font-family: SF Pro Text; */\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: -0.07800000160932541px;\n    text-align: center;\n    color: #000000;\n    opacity: 87%;\n  }\n\n  .bottom-modelTitle {\n    /* font-family: SF Pro; */\n    font-size: 21px;\n    font-weight: 590;\n    line-height: 22px;\n    text-align: center;\n    color: #000000;\n  }\n\n  .bottom-modelDesc {\n    /* font-family: SF Pro; */\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.4099999964237213px;\n    text-align: center;\n    color: #000000;\n    opacity: 87%;\n  }\n\n  /* .bottom-modelDesc #b {\n    font-family: SF Pro;\n    font-size: 14px;\n    font-weight: 510;\n    line-height: 12px;\n    letter-spacing: -0.4099999964237213px;\n    text-align: center;\n  } */\n\n\n\n  .getTheAppCenetr {\n    /* width: 374px;\n    height: 50px; */\n    top: 783px;\n    left: 20px;\n    border-radius: 30px;\n    /* margin-left: -10px; */\n    width: 230px;\n    height: 40px;\n    background: #0195F7;\n    color: #FFFFFF;\n  }\n\n  /* .postWoner {\n    border-top: 1px solid #ccc;\n    margin-top: 12px;\n    border-left: 1px solid #ccc;\n    border-right: 1px solid #ccc;\n  } */\n\n  .modalUserProfile {\n    /* left: 50%; */\n    margin: -33px 0px 0px 0px;\n  }\n\n  .modalUserProfileCenter {\n    /* left: 50%; */\n    margin: -33px 0px 0px 0px;\n  }\n\n/*\n  .image_profile_post {\n    width: 385px;\n    height: 385px;\n    padding-top: 0px;\n    margin-left: 0px;\n  }\n*/\n}\n\n.modalUserProfile {\n  /* left: 50%; */\n  margin: -57px 0px 0px 0px;\n}\n\n.modalUserProfileCenter {\n  /* left: 50%; */\n  margin: -57px 0px 0px 0px;\n}\n\n.fade.modal.show  {\n  padding: 0px !important;\n}\n.img_data_modal {\n  /* width: 15%; */\n  position: relative;\n  /* float: left; */\n  padding: 10px 0px; \n}\n.dontMissModal {\n  z-index: 9999;\n}\n.seeTheFullProfileInAppModalDialog .getTheApp {\n  font-weight: normal;\n  margin: 0 auto;\n}\n/* desktop version */\n@media (min-width: 992px) {\n  .dontMissModalDialog, .seeTheFullProfileInAppModalDialog.midSeeMorePopup {\n    max-width: 330px;\n  }\n\n  .seeTheFullProfileInAppModalDialog {\n    max-width: 428px;\n  }\n  \n  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,\n  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{\n    /* width: 33.3%;\n    left: 33.3%; */\n    max-width: 428px;\n    /* margin: 0 40px; */\n  }  \n\n  .max428 {\n    max-width: 428px;\n  }\n  .m040{\n    /* margin: 0 40px; */\n  }\n  \n}\n\n\n/* left: 36%;\nwidth: 28%; */\n\n@media (min-width: 1024px) {\n  .m040{\n    margin: 0px;\n  }\n  .dontMissModalDialog {\n    /* left: 36%;\n    width: 26%; */\n  }\n  .seeTheFullProfileInAppModalDialog {\n    /* width: 33.3%;\n    left: 33.3%; */\n  }  \n  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,\n  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{\n\n  }   \n}\n@media (min-width: 1024px) {\n\n  .dontMissModalDialog {\n    /* left: 36%;\n    width: 28%; */\n  }\n\n  .sticky-div {\n    width: 33.33333%;\n  }  \n}\n\n\n@media (min-width: 1440px) {\n  .m040{\n    margin: 0px 24px;\n  }\n  .dontMissModalDialog {\n    /* left: 36.4%;\n    width: 27%; */\n    /* left: 38.5%;\n    width: 23%; */\n  }\n  .seeTheFullProfileInAppModalDialog {\n    /* left: 34.9%; */\n    width:auto;\n  }  \n  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,\n  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{\n    /* left: 34.9%; */\n  }   \n}\n\n@media (min-width: 1536px) {\n  .dontMissModalDialog {\n\n    /* left: 37.5%;\n    width: 23%; */\n  }\n}\n\n@media (min-width: 2560px) {\n  .m040{\n    margin: 0px 214px;\n  }\n  .dontMissModalDialog {\n    /* width: 15.3%;\n    left: 42.4%; */\n  }\n  .seeTheFullProfileInAppModalDialog {\n    /* left: 41.7%; */\n  }  \n  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,\n  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{\n    /* left: 41.7%; */\n  }   \n}\n\n.dontMissModalDialog .modal-content,\n.seeTheFullProfileInAppModalDialog .modal-content {\n  background-color: #FFF !important;\n  border: none !important;\n  border-radius: 20px;\n}\n\n.seeTheFullProfileInAppModalDialog.showInBottomContinueWebsite{\n  min-height: 40%;\n    background: #fff;\n    border-radius: 20px 20px 0 0;\n}\n\n.seeTheFullProfileInAppModalDialog.showInBottomContinueWebsite .modal-content {\n  border-bottom-left-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n}\n\n.data-match-dot-dot {\n  /* width: 27px; */\n  padding: 25px 0px;\n  float: right;\n  display: flex;\n  justify-content: end;\n}\n.data-match-dot-dot>span {\n  height: 5px;\n  width: 5px;\n  background-color: #2d97f7;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0px 2px 0px 0px;\n}\n\n.data-match-dot-dot {\n  width: 27px;\n  padding: 25px 0px;\n  float: right;\n  display: flex;\n  justify-content: end;\n}\n\nspan.time-dot {\n  height: 4px;\n  width: 4px;\n  background-color: gray;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 2px 8px;\n}\n\n.postTextView .postText a:link,\n.postTextView .postText a:visited,\n.postTextView .postText a:hover,\n.postTextView .postText a:active{ \n  text-decoration: none; \n} \n\n@media (max-width: 424px) {\n  .data-match-dot-dot {\n    width: 23px;\n  }\n}\n\n@media (max-width: 374px) {\n  .data-match-dot-dot {\n    width: 20px;\n  }\n}\n@media (min-width: 768px) {\n  .data-match-dot-dot {\n    width: 22px;\n  }\n}\n\n.postMedia {\n  /* border-bottom: 1px solid gainsboro; */\n}\n\n.linkPreviewRightBoxContainer{\n  display: table;\n  width: 100%;\n}\n\n.linkPreviewLeftBox {\n  width: 40%;\n  padding: 0px;\n  display: table-cell;\n}\n\n.linkPreviewRightBox {\n  width: 60%;\n  padding: 0px;\n  background: lightgrey;\n  display: table-cell;\n  vertical-align: middle;\n  margin: auto;\n}\n\n.linkPreviewRightBox .linkPreviewRightBox2 {\n  /* vertical-align: middle;\n  margin: auto; */\n  padding: 0px 5px;\n}\n.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 {\n  /* vertical-align: middle;\n  margin: auto; */\n}\n\n.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 a:link,\n.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 a:visited,\n.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 a:hover,\n.linkPreviewRightBox .linkPreviewRightBox2 .linkPreviewRightBox3 a:active {\n  color: black;\n  text-decoration:none;\n}\n/* @media (max-width: 424px) {\n  .data-match-dot-dot {\n    width: 23px;\n  }\n} */\n\n/* different techniques for iPad screening */\n@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {\n  /* For portrait layouts only */\n}\n\n@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\n  /* For landscape layouts only */\n}\n@media only screen and (min-device-width: 768px) and (max-device-width: 1023px){\n  .p0170 {\n    margin: 0px 170px !important;\n  }\n  .dontMissModalDialog.p0170 {\n    /* margin: 0px 150px !important; */\n  }\n\n  .seeTheFullProfileInAppModalDialog .modal-content {\n    width: 425px;\n  }\n\n  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,\n  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{\n    width: 428px;\n  }  \n\n  #PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content,\n  #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content{\n    /* margin: 0px 170px !important; */\n  }\n\n  .dontMissModalDialog .modal-content {\n    width: 360px;\n  }\n\n  .dontMissModalDialog {    \n    /* left: 7%; */\n  }\n\n}\n\n@media screen and (min-width: 1400px) {\n  .postCard {\n    width: 850px;\n  }\n  .postCard2 {\n    width: 850px;\n  }\n  .postCard3 {\n    width: 850px;\n  }\n}\n\n\n.modal-dialog.modal-dialog-centered .imageViewBoxFullScreen {\n  /* width: 100% !important; */\n  /* height: 100% !important; */\n}\n\n.modal-dialog.modal-dialog-centered .imageViewBox {\n  /* width: 100% !important; */\n  /* height: 100% !important; */\n}\n/* #PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content .imageViewBox */\n\n#PostInFullScreenVerticallyCenteredModal.modal-dialog.modal-dialog-centered .modal-content .imageViewBoxFullScreen\n#PostInFullScreenVerticallyCenteredModal2.modal-dialog.modal-dialog-centered .modal-content .imageViewBoxFullScreen {\n  width: 100% !important;\n  /* left: 33.3%; */\n}\n\n\n.modal-dialog.modal-dialog-centered {\n  margin: 0px;\n}\n\n.modal-dialog.modal-dialog-centered .modal-header {\n  width: 30px;\n  height: 30px;\n  border: 0;\n  position: absolute;\n  z-index: 1;\n  /* top: -7px; */\n  /* left: -20px; */\n  padding: 0px;\n}\n\n.modal-dialog.modal-dialog-centered .img_container1 img, \n.modal-dialog.modal-dialog-centered .img_container2 img, \n.modal-dialog.modal-dialog-centered .imageViewBox img,\n.modal-dialog.modal-dialog-centered .imageViewBox2 img, \n.modal-dialog.modal-dialog-centered .imageViewBox3Single img, \n.modal-dialog.modal-dialog-centered .imageViewBox225 img,\n.modal-dialog.modal-dialog-centered .videoExplrView img\n{\n  object-fit: contain;\n}\n\n.modal-dialog.modal-dialog-centered .videoExplrView .startPlayIcon {\n  left: 60%;\n}\n\n.modal-dialog.modal-dialog-centered .modal-header button\n{\n  /* background-color: gray; */\n  /* height: 0px; */\n  /* padding: 3px;\n  left: -2px; */\n  position: relative;\n  top: 7px;\n  /* width: 2em;\n  height: 2em; */\n}\n\n.modal-dialog.modal-dialog-centered .videoViewCount {\n  float: right;\n  position: absolute;\n  border-bottom-right-radius: initial;\n  border-bottom-left-radius: 20%;\n  right: 6px;\n}\n\n.modal {\n  --bs-modal-width: 100% !important;\n}\n\n.btn-close {\n  --bs-btn-close-bg: url('./assets/icon/icone-x-bleue3.png') !important;\n  opacity: 1;\n}\n\n/*\n.lds-ellipsis \n*/\n\n.scroll-div  #ptr-parent #ptr-pull-down #container .sk-fading-circle\n{\n  background-image: url('./assets/icon/refresh2.gif') !important;\n  background-size: contain;\n  background-position: center;\n  width: 1.5em !important;\n  background-repeat: no-repeat;\n  display: block;\n}\n\n.sk-fading-circle .sk-circle {\n  display: none !important;\n}\n\n.p010{\n  padding: 0px 10px;\n}\n\n.postWoner .data-match {\n  width: 85%;\n}\n\n.bbtm {\n  border-bottom: .4px solid #cccccc;\n}\n\n.bt {\n  border-top: .4px solid #cccccc;\n}\n\n.postText .text {\n  margin-bottom: 0px;\n}\n\n.read-or-hide {\n  color: #2d97f7 !important;\n}\n\n.profile-pic-post-row.imageViewBox {\n  /* filter: blur(20px); */\n  /* background-size: cover; */\n  /* opacity: .3; */\n}\n\n.profile-pic-post-row2.polygonBox {\n  position: absolute;\n  top: 0px;\n}\n.b1lg {\n  border: .4px solid #cccccc;\n}\n\n\n.BoxPostWoner2  .profile-pic-post-row2.polygonBox {\n  bottom: 0px;\n  top: auto;\n}\n\n.kudoVal2 {\n  float: left;\n  margin-left: 3px;\n}\n\n.spreadVal2 {\n  float: right;\n  margin-right: 10px;\n}\n@media screen and (max-width: 425px) {\n  .kudoVal {\n    margin-left: -10px;\n  }\n  .kudo-count-container {\n    margin-left: 10px;\n  }\n  .footer-left-inner4 {\n    width: 44%;\n    padding: 0 5px;\n  }\n  .footer-left-inner5 {\n    width: 56%;\n    padding: 0 5px;\n  }\n  .kudo-mark {\n    margin-right: 0px;\n  }\n}\n\n.splashScreen img {\n  text-align: center;\n  width: -webkit-fill-available;\n}\n\n.no_explurge_yet {\n    justify-content: center;\n    display: flex;\n    /* padding: 20px 0; */\n    text-align: center;\n}\n.no_explurge_yet div {\n   padding: 5px 0px;\n}\n\n.profile-img-box {\n  min-height: 180px;\n  max-height: 180px; \n}\n\n.profile-img {\n  max-width: inherit;\n  min-height: 180px;\n  max-height: 180px;\n  width: -webkit-fill-available;\n}\n.mt10 {\n  margin-top: 10px;\n}\n.mtb10 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.mtminus60 {\n  margin-top: -80px;\n}\n.Level_Icon_Profile {\n  border: 1px solid lightgray;\n  /* padding: 5px 10px; */\n  /* margin: 10px 10px; */\n  background-color: white;\n  /* display: inline-block; */\n  /* position: relative; */\n  /* top: 25px; */\n  border-radius: 15%;\n  /* right: -10px; */\n  width: 80px;\n}\n\n.postCardMP{\n  margin-top: -10px;\n  padding: 0px;\n}\n\n.Level_Icon_Profile_Text {\n  justify-content: center;\n  display: flex;\n  /* right: -10px; */\n  position: relative;\n  color: #2d97f7;\n  font-size: 14px;\n  text-align: center;\n}\n\n.explr-col-3 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.explr-col-31 {\n  flex: 0 0 auto;\n  width: 34.33333333%;\n}\n.explr-col-32 {\n  flex: 0 0 auto;\n  width: 30.2%;\n}\n.ExplurgedLevelIconViewProfileBox {\n  right: -10px;\n  position: relative;\n}\n\n.ExplurgedLevelIconViewProfile {\n  display: flex;\n  justify-content: center;\n  margin: 30px 0px 0px;\n}\n\n.explr-profile .image_profile {\n\n}\n\n.p10 {\n  padding: 10px;\n}\n\n.p15Z{\n  padding: 0px 15px;\n  top: -15px;\n  position: relative;\n}\n\n.mapProfileMapBox {\n  width: 8%;\n}\n\n.mapProfileSummeryBox {\n  display: flex;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: bold;\n  color: #2d97f7;\n  /* width: 90%; */\n  align-items: center;\n}\n\n.profile-summary-box {\n  /* min-height: 230px; */\n  margin: 10px 0px 0px;\n  width: inherit;\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;  \n}\n\n.profile-hex-box2 {\n  position: relative;\n  left: 12%;\n}\n\n.profile-summary-box-list-2 {\n  top: -10px;\n  position: relative;\n}\n.p2010 {\n  padding: 20px 20px;\n}\n\n.profile-summary-place-img {\n  top: 50px;\n  position: absolute;\n}\n\n.profile-summary-place-jpg {\n  width: inherit;\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n\n.block-box-summary {\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.block-box-post {\n  border-radius: 0px;\n}\n\n.m10px0 {\n  margin: 10px 0px;\n}\n\n.postSummeryBox {\n  display: flex;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: bold;\n  color: #2d97f7;\n  width: 100%;\n  align-items: center;\n}\n\n.link-color a {\n  color: #2d97f7 !important;\n}\n\n.bucketUsers1 {\n  width: 20%;\n  float: left;\n  padding-top: 8px;\n}\n\n.bucketTest {\n  width: 40%;\n  float: left;  \n  justify-content: center;\n  display: flex;\n  vertical-align: middle;\n  position: relative;\n  align-items: center;\n}\n\n@media screen and (max-width: 425px) {\n  .bucketTest {\n    /* margin-top: -8px; */\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1270px) {\n  .bucketTest {\n    /* margin-top: -8px; */\n  }\n}\n\n@media screen and (min-width: 425px) and (max-width: 768px) {\n  .bucketTest {\n    width: auto;\n  }\n}\n\n@media screen and (min-width: 1440px) and (max-width: 2560px) {\n  .bucketTest {\n    width: auto;\n  }\n}\n\n.profileButtonsBox {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  vertical-align: middle;\n  position: relative;\n}\n\n.profileButtonsBoxInner {\n  position: relative;\n  align-items: center;\n  /* justify-content: center; */\n  vertical-align: middle;\n  display: flex;\n}\n\n.profileButtonsBoxInnerRight {\n  position: relative;\n  align-items: center;\n  justify-content: right;\n  vertical-align: middle;\n  display: flex;\n}\n\n.profileButtons {\n  border-radius: 25px;\n  width: auto;\n  background-color: #0d6efd !important;\n  /* padding: 3px; */\n}\n\n\n.profileButtonsFollow {\n  /* width: 100px; */\n  background-color: #0d6efd !important;\n}\n\n.profileButtonsMessage {\n  /* width: 90px; */\n  background-color: #D9D9D9 !important;\n  color: black !important;\n  border: none;\n}\n\n.profileButtonsShare {\n  /* width: 50px; */\n  background-color: #D9D9D9 !important;\n  /* padding: 5px; */\n  color: black !important;\n  border: none;\n}\n\n.mzz10{\n  margin: 0px 0px 10px;\n}\n\n.m5Z{\n  margin: 5px 0px;\n}\n\n.fs16B {\n  font-size: 16px;\n  font-weight: bold;\n  color: black;\n}\n\n.fs14N {\n  font-size: 14px;\n  font-weight: normal;\n  color: #666;\n}\n\n\n.mtminus60 {\n  /* margin-top: -80px; */\n}\n\n@media screen and (max-width: 768px) {\n  .ExplurgedLevelIconViewProfile {\n    margin: 30px 0px 0px;\n  }\n  .mtminus60 {\n    margin-top: -85px;\n  }  \n  .profileButtonsFollow {\n    width: 100px;\n  }\n}\n\n@media screen and (max-width: 375px) {\n  .mtminus60 {\n    margin-top: -75px;\n  }\n\n  .Level_Icon_Profile {\n    width: 60px;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .ExplurgedLevelIconViewProfile {\n    /* margin: 20px 0 0; */\n  }\n  .mtminus60 {\n    margin-top: -90px;\n  }\n  .profileButtonsBoxInnerRight {\n    /* justify-content: center; */\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .ExplurgedLevelIconViewProfile {\n    margin: 20px 0px 0px;\n  }\n  .mtminus60 {\n    margin-top: -75px;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .ExplurgedLevelIconViewProfile {\n    margin: 30px 0px 0px;\n  }\n  .mtminus60 {\n    margin-top: -85px;\n  }\n}\n\n\n@media screen and (min-width: 1024px) and (max-width: 1024px){\n  .ExplurgedLevelIconViewProfile {\n    margin: 30px 0px 0px;\n  }\n  .Level_Icon_Profile {\n    width: 65px;\n  }\n}\n\n.bucketTest .btn-bucket-center{\n  padding-left: 0px;\n}\n\n.summary-hex-count {\n  font-size: 16px;\n  font-weight: bold;\n}\n.summary-hex-text {\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.welcomeBox {\n  padding: 10px 0px 0px;\n}\n\n#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n.scroll-div .loaderbox{\n  padding-top: 20px;\n}\n.post-view-list .loaderbox{\n  margin: 20px;\n}\n#staticContinueWebsiteBox,\n#dontMissModalBox,\n#staticBackdropBox{\n  /* width: 100vw;\n  height: 100vh; */\n}\n\n/* new UI chnages 08-08-2025 */\n\n.circle_profile400 {\n  width: 100%;\n  height: auto;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n  padding: 10px;\n}\n.circle_profile {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_xsmall {\n  width: 25px;\n  height: 25px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_small {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_medium {\n  width: 70px;\n  height: 70px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_large {\n  width: 120px;\n  height: 120px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_large130 {\n  width: 130px;\n  height: 130px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_xlarge {\n  width: 150px;\n  height: 150px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_xxlarge {\n  width: 200px;\n  height: 200px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_xxxlarge {\n  width: 250px;\n  height: 250px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n.circle_profile_xxxxlarge {\n  width: 300px;\n  height: 300px;\n  object-fit: cover;   /* keeps aspect ratio, fills space */\n  border-radius: 50%;  /* makes it a perfect circle */\n}\n\n.profile-pic-post-row2.polygonBox {\n  /* top: 0px; */\n  top: 10px;\n}\n\n#dontMissModalBox .modalUserProfileCenter {\n  display: contents;\n}\n\n.imageViewBox3Single img {\n  /* max-height: 100%; */\n  max-height: 425px;\n}\n\n.block-box {\n  border-radius: 0px;\n  margin-top: 1px;\n}\n\n\n.post-user-names-box {\n  margin-top: 10px;\n}\n\n.post-user-names-box\n.kudo-count-container {\n    display: flex;\n    align-items: center;\n}\n.post-user-names-box\n.kudo-user-names {\n    display: flex;\n    align-items: center; \n    gap: 8px; \n}\n.post-user-names-box\n.kudo-user-names .kudosUserPics {\n    display: flex;\n    align-items: center; \n    margin-left: 10px;\n}\n.post-user-names-box\n.kudo-user-names div img {\n    display: flex;\n    align-items: center;\n    margin-left: -10px;\n}\n.post-user-names-box\n.kudo-user-names > div:first-child {\n    display: flex;\n    align-items: center; \n    gap: 4px;\n}\n\n.post-user-names-box\n.names1-names2 {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.footer-post-kudos-view-box\n  .footer-post-kudos-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 0 15px;\n  }\n\n.footer-post-kudos-view-box\n  .footer-post-kudos-container\n  p {\n    float: left;    \n    margin: 0;\n    /* padding: 8px; */\n    white-space: nowrap;    \n  }\n\n/* Last column: fixed width */\n.footer-post-kudos-view-box\n.footer-post-kudos-container p.text-right {\n    margin-left: auto;\n    text-align: right;\n    margin-right: 10px;\n}\n\n/* First 3: shrink-to-fit content */\n.footer-post-kudos-view-box\n.footer-post-kudos-container p:not(.text-right) {\n    /* flex: 0 0 auto;  */\n    /* size based on content */\n}  \n\n.footer-post-kudos-view-box\n.footer-post-kudos-container p\nimg.kudimage {\n    width: 22px;\n    height: 25px;\n    padding: 2px;\n}\n\n.footer-post-kudos-view-box\n.footer-post-kudos-container p\nimg.saysimage {\n    width: 25px;\n    height: 25px;\n    padding: 2px;\n}\n\n.footer-post-kudos-view-box\n.footer-post-kudos-container p\nimg.spreadimage {\n    width: 25px;\n    height: 25px;\n    padding: 2px;\n}\n\n.data-match-dot-dot {\n    /* width: 27px; */\n    padding: 20px 0px;\n    float: right;\n    display: flex;\n    flex-direction: column;  /* vertical stack */\n    align-items: end;     /* center horizontally */\n    justify-content: flex-start; /* stick to top */\n}\n\n.data-match-dot-dot > span {\n    height: 5px;\n    width: 5px;\n    background-color: #000; /* #2d97f7 */\n    border-radius: 50%;\n    display: inline-block;\n    margin: 2px 0; /* vertical spacing */\n}\n\n.block-box.post-box\n.postString {\n  margin-left: 0px;\n}\n\n.block-box.post-box\n.img_data {\n  padding: 20px 0 0;\n}\n.block-box.post-box\n.data-match\n.data_left\n{\n  float: none;\n}\n\n.block-box.post-box\n.data-match {\n  padding: 20px 0px 0;\n}\n\n\n.b1l_t {\n  border-top: .4px solid #cccccc;\n}\n\n\n.Circle_Level_Icon {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    position: absolute;\n    right: 0px;\n    background-color: rgb(120 113 113 / 40%);\n    margin: 10px;\n}\n\n.Circle_Level_Icon .Level_Icon2 {\n    height: 40px;\n    position: absolute;\n    z-index: 999;\n    margin: 5px 20%;\n}\n/********journey_so_for*********/\n    .stats-card {\n      background: #f9f9f9;\n      border-radius: 15px;\n      padding: 5px;\n      text-align: center;\n      box-shadow: 0px 2px 6px #00000040;\n      transition: transform 0.2s ease-in-out;\n      cursor: pointer;\n  \n    }\n    .stats-card:hover {\n      transform: translateY(-3px);\n    }\n    .stats-icon {\n      /* font-size: 2rem; */\n      /* margin-bottom: 10px; */\n      color: #4CAF50;\n      text-align: left;\n    }\n    .stats-value {\n      font-size: 1.5rem;\n      font-weight: bold;\n      text-align: right;\n    }\n    .stats-label {\n      font-size: 0.75rem;\n      color: #555;\n      text-align: right;\n    }\n\n/* element.style {\n    text-align: right;\n}     */\n\n.profile-summary-place-img {\n    top: inherit;\n}\n\n.journey_so_for_image {\n  width: 25px;    \n  height: 25px;\n  margin: 5px 0px;\n}\n\n.journey_so_for_image.miles {\n    margin: 5px 0px;\n    width: 16px;\n    height: auto;\n}\n\n/*****will-go-to****/\n\n.Will-Go-To-Box {\n  background-color: gainsboro;\n}\n\n.will-go-to-month-day {\n    background-color: #413a3a;\n    white-space: break-spaces;\n    padding: 3px;\n    color: wheat;\n    margin: 0 2px;\n}\n\n.m5Z {\n    margin: 1px 0px;\n}\n.Level_Icon_Profile {\n  width: 65px;\n}\n\n.circle_profile_large130 {\n  width: 108px;\n  height: 108px;\n}\n\n.ExplurgedLevelIconViewProfile {\n    justify-content: end;\n    text-align: right;\n}\n\n.Level_Icon_Profile_Text {\n    /* justify-content: end;\n    text-align: right; */\n}\n\n.profileButtonsFollow,\n.profileButtonsMessage,\n.profileButtonsShare {\n  width: 100%;\n}\n\n.profileButtonsFollow {\n  background-color: #0195F7 !important;\n}\n\n.profile-pic-post-row2.polygonBox {\n    top: 0px;\n    /* top: 10px; */\n}\n\n.bucketTest .btn-bucket-center {\n    margin-top: 0px;\n    display: flex;\n    align-items: center;   /* Vertical align */\n    justify-content: center;\n    min-height: 35px;\n    max-height: 35px;\n}\n\n.bucketTest .btn-bucket-center b {\n  padding: 0 3px;\n  display: contents;\n}\n.explurgen-with-media\n.flex-parent\n.Map_Photo_Box img.Map_Photo_Img {\n  /* object-fit: cover; */\n}\n\n\n.bucketTest {\n    width: 50%;\n    justify-content: start;\n}\n\n.profile-img {\n    min-height: 150px;\n    max-height: 150px;\n}\n\n.circle_profile_large130 {\n    width: 100px;\n    height: 100px;\n    border: 2px solid white;\n}\n\n    .mtminus60 {\n        margin-top: -100px;\n    }\n\n    .ExplurgedLevelIconViewProfile {\n        margin: 25px 0px 0px;\n    }\n\nbody.modal-open {\n  /* position: fixed;\n  width: 100%; */\n  overflow: hidden;\n}\n\n\n\n@media (max-width: 424px) {\n  .block-box.post-box .data-match {\n    padding: 20px 0 0 10px;\n  }\n}\n\n#staticContinueWebsite,\n#staticContinueWebsiteBox,\n#staticBackdrop,\n#dontMissModalBox,\n#staticBackdropBox {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  height: 100vh;   \n  /* fallback */\n  height: 100dvh;  \n  /* modern Safari overrides */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 0;   /* override */\n  margin-bottom: 0;    /* override */  \n  z-index: 9999;\n}\n\n#staticContinueWebsiteBox,\n#staticBackdropBox\n.modal-backdrop {\n  width: 100%;\n  height: 100%;\n  height: 100dvh;  \n\n  padding-bottom: 0;   /* override */\n  margin-bottom: 0;    /* override */  \n}\n\n@media (min-width: 1024px) {\n  .sticky-div {\n    width: 428px;\n    /* max-width: 100%; */\n  }  \n}\n\n@media (min-width: 428px) {\n  .sticky-div {\n    /* width: 428px; */\n    max-width: 100%;\n  }  \n}\n\n    /* Sticky header */\n    header.sticky_top_header {\n      position: sticky;\n      top: 0;\n      z-index: 1000;\n      background: #fff;\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n      padding: 0 10px;\n    }\n\n    header.sticky_top_header .header-inner {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 8px 0;\n    }\n\n    header.sticky_top_header .header-logo {\n      max-height: 40px;\n    }\n\n    header.sticky_top_header .top_container.container {\n        margin-top: auto;\n        padding-left: auto;\n        margin-left: auto;\n        z-index: 1000;\n        padding-right: auto;\n    }\n   \n\n    @media (min-width: 992px) {\n        header.sticky_top_header .top_container {\n            max-width: 525px;\n        }\n    }\n\n    @media (min-width: 1200px) {\n      header.sticky_top_header .top_container {\n        max-width: 800px;\n      }\n    }    \n\n.post-user-names-box\n.names1-names2 div {\n  float: left;\n}\n\n\n@media (max-width: 320px) {\n  .bucketTest .btn-bucket-center {\n    /* font-size: smaller; */\n    font-size: 10px;\n  }\n  .AddbucketListBtn {\n    width: 88px;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1024px) {\n    .scroll-div\n    .p0170 {\n        margin: unset !important;\n    }\n    .max428 {\n        width: 35%;\n    }\n    /* \n    .dontMissModalDialog {\n        left: 21%;\n    }\n\n    .seeTheFullProfileInAppModalDialog {\n        left: 12%;\n    }     \n    */\n    \n}\n\n\n.profile-img-box-image {\n    min-height: 150px;\n    max-height: 150px;\n}\n\n.post-box .img_data .circle_profile_small {\n  width: 40px;\n  height: 40px;\n}\n\n.Circle_Level_Icon {\n    width: 45px;\n    height: 45px;\n}\n\n.Circle_Level_Icon .Level_Icon2 {\n    height: 35px;\n}\n\n.circle_profile400 {\n    padding: unset;\n    border: 1px solid white;\n}\n\n.profile-pic-post-row2.polygonBox {\n  padding: 10px;\n}\n\n.link-color a{\n  text-decoration: none;\n}\n\n.main_container,\n.seeTheFullProfileInAppModalDialog ,\n.dontMissModalDialog {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n#staticContinueWebsiteBox #staticContinueWebsite.modal.staticContinueWebsite,\n#dontMissModalBox #dontMissModal.modal.dontMissModal,\n#staticBackdropBox #staticBackdrop.modal.staticBackdrop {\n    display: flex;\n    justify-content: center;\n    align-items: center;  \n}\n\n#PostInFullScreenVerticallyCenteredModal,\n#PostInFullScreenVerticallyCenteredModal2 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.modal-dialog.seeTheFullProfileInAppModalDialog.showInBottomContinueWebsite {\n    position: fixed;\n    bottom: 0 !important;\n    margin: 0 !important;\n    margin-bottom: -5px !important;\n    width: 100%;\n}\n\n/* .block-box.post-box .postCard .img_data, */\n.block-box.post-box .postCard2 .img_data {\n    width: 13%;\n}\n\n.w50p {\n  width: 50%;\n}\n\n.pd05 {\n  padding: 0px 5px;\n}\n\n.btn-bucket-center {\n    color: #000;\n}\n\n.profile-img {\n  width: -moz-available;\n  object-fit: cover;\n}\n\n.splashScreen img {\n  width: -moz-available;\n}\n\n.no_explurge_yet .header-logo {\n    max-height: 100px;\n}\n\n.link-secondary {\n  text-decoration: none;\n}\n\n@media (min-width: 1200px) {\n  .main_container\n  .no_explurge_yet \n  .display-6 {\n      font-size: 2.0rem;\n  }\n}\n.main_container\n.no_explurge_yet \n.fs-5 {\n    font-size: 1.10rem !important;\n}\n\n/* For small screens only */\n@media screen and (max-width: 767px) {\n  .seeTheFullProfileInAppModalDialog {\n    bottom: 25px;\n  }\n}\n\n.modal-dialog.seeTheFullProfileInAppModalDialog {\n  bottom: auto !important;\n}\n\n\n.profileButtonsOpenAppBtn {\n  width: auto !important;\n}\n\n#PostInFullScreenVerticallyCenteredModal2,\n#PostInFullScreenVerticallyCenteredModal {\n  align-items: flex-start;\n}\n\n.videoExplrView > div[data-vjs-player=\"true\"] > div[webkit-playsinline=\"true\"]{\n    justify-content: center;\n    display: flex;\n}\n\n\n/* Ensure modal is truly full-screen and centered */\n/* Ensure modal dialog is perfectly centered and full-width */\n.custom-modal-dialog {\n  margin: 0 !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  position: fixed !important;\n}\n\nbody.modal-open {\n  padding-right: 0 !important;\n}\n\n\n\n/* Slide back down when closing */\n#staticContinueWebsiteBox\n.modal.fade:not(.show) .modal-dialog {\n  transform: translateY(100vh);  \n}\n\n\n.circle_profile_small_continue {\n  width: 83px;\n  height: 83px;\n}\n\n\n.modalUserProfileContinue{\n  margin: 0px;\n}\n\n.txt-continue-head{\n  font-weight: bold;\n  font-size: 21px;\n  margin-bottom: 0;\n\n}\n\n.txt-continue-desc {\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 25px;\n}\n\n.circle_profile_small {\n    width: 83px;\n    height: 83px;\n    border: 1px solid #D3D3D3;\n}\n\n.modalUserProfile {\n    margin: 2px 0 7px 0;\n}\n\n.openInApp {\n  margin-bottom: 15px;\n}\n\n.closeBtnModal {\n  position: fixed;\n  top: 12px;\n  right: 12px;\n  cursor: pointer;\n  z-index: 9999;\n}\n\n.pageNotFoundCloseIcon {\n  right: 10px;\n}\n\n.closeIconStyle {\n  width: 27px;\n  cursor: pointer;\n}\n\n.max-width-80-per{\n  max-width: 80%;\n}\n\n.want-to-engage-txt {\n  font-family: 'SF Pro Light';\n  font-size: 21px;\n  line-height: 25px;\n  margin-bottom: 11px;\n}\n.open-the-app-to-connect{\n  font-size: 13px;\n  line-height: 18px;\n  margin-bottom: 25px;\n}\n\n#dontMissModalBox .modal-backdrop, #staticBackdropBox .modal-backdrop {\n  background-color: #000000;\n    opacity: 0.65;\n}\n\n.post-item {\n  position: relative;\n}\n\n.post-bottom-sentinel {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 1px;\n  height: 1px;\n  pointer-events: none;\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
